import { useState, useEffect } from "react";
import { C, ALL_SIZES, toSlug } from "../data";
import { supabase } from "../supabase";
import { saveProduct as apiSave, deleteProduct as apiDelete, fetchNavCats, saveNavCats, saveProductOrder,
  fetchCoupons, saveCoupon as apiSaveCoupon, deleteCoupon as apiDeleteCoupon, searchProfiles, issueCouponToUsers,
  fetchInventory, upsertInventoryRow, deleteInventoryRow,
  fetchAllReviews, setBestReview,
  fetchReviewComments, addReviewComment, deleteReviewComment, grantPhotoReviewPoints,
  fetchAllPointTransactions, fetchPointSummary,
  adminGrantPoints, adminDeletePointTransaction,
  DEFAULT_SITE_SETTINGS, DEFAULT_INFO_CONTENT,
  fetchMainMenu, saveMainMenu } from "../api";

const F = { ink: C.ink, bg: "#F7F7F7", card: "#fff", border: "#E8E8E6", muted: "#888", accent: C.accent };

function ImgGrid({ imgs, onImg, onRemoveImg, count = 8 }) {
  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
      {Array.from({ length: count }, (_, idx) => idx).map(idx => (
        <div key={idx}>
          {imgs?.[idx] ? (
            <div style={{ aspectRatio:"3/4", border:"2px solid #EEE", borderRadius:4, overflow:"hidden", background:"#F5F5F3", position:"relative" }}>
              <img src={imgs[idx]} style={{ width:"100%", height:"100%", objectFit:"contain", position:"absolute", inset:0 }} alt="" />
              <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.45)", display:"flex", alignItems:"center", justifyContent:"center", gap:20, opacity:0, transition:"opacity .2s" }}
                onMouseEnter={e => e.currentTarget.style.opacity="1"}
                onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                <label style={{ cursor:"pointer" }}>
                  <span style={{ color:"#fff", fontSize:10, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                  <input type="file" accept="image/*" style={{ display:"none" }}
                    onChange={e => onImg(idx, e.target.files[0])} />
                </label>
                {onRemoveImg && (
                  <button onClick={e => { e.preventDefault(); e.stopPropagation(); onRemoveImg(idx); }}
                    style={{ color:"#FF9090", fontSize:10, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2, background:"none", border:"none", cursor:"pointer", padding:0 }}>
                    삭제
                  </button>
                )}
              </div>
            </div>
          ) : (
            <label style={{ cursor:"pointer", display:"block" }}>
              <div style={{ aspectRatio:"3/4", border:"2px dashed #DDD", borderRadius:4, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", overflow:"hidden", background:"#F5F5F3", position:"relative", transition:"border-color .18s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18, marginBottom:6 }}>+</div>
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:"#CCC" }}>{idx === 0 ? "대표" : `${idx+1}`}</span>
              </div>
              <input type="file" accept="image/*" style={{ display:"none" }}
                onChange={e => onImg(idx, e.target.files[0])} />
            </label>
          )}
        </div>
      ))}
    </div>
  );
}

function DynamicImgGrid({ imgs, onImg, onRemoveImg, maxCount = 8 }) {
  const filledImgs = (imgs || []).filter(Boolean);
  const displayImgs = filledImgs.length < maxCount ? [...filledImgs, null] : filledImgs;

  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
      {displayImgs.map((img, idx) => (
        <div key={idx}>
          {img ? (
            <div style={{ aspectRatio:"3/4", border:"2px solid #EEE", borderRadius:4, overflow:"hidden", background:"#F5F5F3", position:"relative" }}>
              <img src={img} style={{ width:"100%", height:"100%", objectFit:"contain", position:"absolute", inset:0 }} alt="" />
              <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.45)", display:"flex", alignItems:"center", justifyContent:"center", gap:20, opacity:0, transition:"opacity .2s" }}
                onMouseEnter={e => e.currentTarget.style.opacity="1"}
                onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                <label style={{ cursor:"pointer" }}>
                  <span style={{ color:"#fff", fontSize:10, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                  <input type="file" accept="image/*" style={{ display:"none" }}
                    onChange={e => onImg(idx, e.target.files[0])} />
                </label>
                {onRemoveImg && (
                  <button onClick={e => { e.preventDefault(); e.stopPropagation(); onRemoveImg(idx); }}
                    style={{ color:"#FF9090", fontSize:10, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2, background:"none", border:"none", cursor:"pointer", padding:0 }}>
                    삭제
                  </button>
                )}
              </div>
            </div>
          ) : (
            <label style={{ cursor:"pointer", display:"block" }}>
              <div style={{ aspectRatio:"3/4", border:"2px dashed #DDD", borderRadius:4, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", overflow:"hidden", background:"#F5F5F3", position:"relative", transition:"border-color .18s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18, marginBottom:6 }}>+</div>
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:"#CCC" }}>{idx + 1}</span>
              </div>
              <input type="file" accept="image/*" style={{ display:"none" }}
                onChange={e => onImg(idx, e.target.files[0])} />
            </label>
          )}
        </div>
      ))}
    </div>
  );
}

function AdmInput({ label, ...props }) {
  return (
    <div>
      {label && <label className="adm-label">{label}</label>}
      <input className="adm-input" {...props} />
    </div>
  );
}

export default function AdminPage({ products, onProductsChange, onGoHome, navCats, onNavCatsChange, mainMenu: mainMenuProp, onMainMenuChange, slides: slidesProp, onSlidesChange, saveSlides, brandImages: brandImagesProp, onBrandImagesChange, saveBrandImages, siteSettings: siteSettingsProp, onSiteSettingsChange, saveSiteSettings, infoContent: infoContentProp, onInfoContentChange, saveInfoContent: apiSaveInfoContent }) {
  const [auth,      setAuth]      = useState(false);
  const [view,      setView]      = useState("list");   // "list" | "edit" | "add"
  const [form,      setForm]      = useState(null);
  const [loginUser,    setLoginUser]    = useState("");
  const [loginPass,    setLoginPass]    = useState("");
  const [loginErr,     setLoginErr]     = useState("");
  const [loginTries,   setLoginTries]   = useState(0);
  const [loginLocked,  setLoginLocked]  = useState(false);
  const [lockUntil,    setLockUntil]    = useState(null);
  const [copied,    setCopied]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [navForm,        setNavForm]        = useState(null);
  const [navSaving,      setNavSaving]      = useState(false);
  const [mainMenuForm,   setMainMenuForm]   = useState(null);
  const [mainMenuSaving, setMainMenuSaving] = useState(false);
  const [slidesForm,   setSlidesForm]   = useState(null);
  const [slidesSaving, setSlidesSaving] = useState(false);
  const [brandForm,       setBrandForm]       = useState(null);
  const [brandSaving,     setBrandSaving]     = useState(false);
  const [siteSettingsForm, setSiteSettingsForm] = useState(null);
  const [siteSettingsSaving, setSiteSettingsSaving] = useState(false);
  const [orderForm,    setOrderForm]    = useState(null);
  const [orderSaving,  setOrderSaving]  = useState(false);
  const [dragIdx,      setDragIdx]      = useState(null);

  // 주문 관리
  const [allOrders,      setAllOrders]      = useState([]);
  const [ordersLoading,  setOrdersLoading]  = useState(false);
  const [expandedOrder,  setExpandedOrder]  = useState(null);
  const [statusSaving,   setStatusSaving]   = useState(null);
  const [orderSearch,    setOrderSearch]    = useState("");
  const [orderStatusFilter, setOrderStatusFilter] = useState("all");
  const [orderSortAsc,   setOrderSortAsc]   = useState(false);

  // 쿠폰 관리
  const [coupons,        setCoupons]        = useState([]);
  const [couponsLoading, setCouponsLoading] = useState(false);
  const [couponForm,     setCouponForm]     = useState(null);
  const [couponSaving,   setCouponSaving]   = useState(false);
  const [issuePanelFor,  setIssuePanelFor]  = useState(null); // coupon id | null
  const [userQuery,      setUserQuery]      = useState("");
  const [userResults,    setUserResults]    = useState([]);
  const [selectedUsers,  setSelectedUsers]  = useState([]);
  const [issuing,        setIssuing]        = useState(false);

  // Info 페이지 콘텐츠 관리
  const [infoContentForm,   setInfoContentForm]   = useState(null);
  const [infoContentSaving, setInfoContentSaving] = useState(false);
  const [infoEditType,      setInfoEditType]      = useState("contact");

  // 게시판 관리
  const [adminNotices,   setAdminNotices]   = useState([]);
  const [noticeForm,     setNoticeForm]     = useState({ id: null, title: '', content: '', imageUrl: '' });
  const [noticeSaving,   setNoticeSaving]   = useState(false);
  const [noticeImgUploading, setNoticeImgUploading] = useState(false);
  const [noticeEditMode, setNoticeEditMode] = useState(false);
  const [adminInquiries, setAdminInquiries] = useState([]);
  const [inquiryFilter,  setInquiryFilter]  = useState("all"); // all | pending | answered
  const [inquiryReplies, setInquiryReplies] = useState({});
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [replyContent,   setReplyContent]   = useState('');
  const [replySaving,    setReplySaving]    = useState(false);

  // 재고 관리
  const [inventoryProduct, setInventoryProduct] = useState(null);
  const [inventoryRows,    setInventoryRows]    = useState([]);
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryForm,    setInventoryForm]    = useState({ size: '', color_name: '', quantity: 0 });

  // 베스트 리뷰
  const [allReviews,      setAllReviews]      = useState([]);
  const [reviewsLoading,  setReviewsLoading]  = useState(false);
  const [bestSaving,      setBestSaving]      = useState(null);

  // 리뷰 관리
  const [adminReviews,       setAdminReviews]       = useState([]);
  const [adminReviewTotal,   setAdminReviewTotal]   = useState(0);
  const [adminReviewPage,    setAdminReviewPage]    = useState(0);
  const [adminReviewLoading, setAdminReviewLoading] = useState(false);
  const [selectedReview,     setSelectedReview]     = useState(null);
  const [reviewCommentMap,   setReviewCommentMap]   = useState({});
  const [reviewCommentText,  setReviewCommentText]  = useState('');
  const [reviewCommentSaving,setReviewCommentSaving]= useState(false);
  const [reviewListFilter,   setReviewListFilter]   = useState('all');

  // 회원 목록
  const [members,        setMembers]        = useState([]);
  const [membersLoading, setMembersLoading] = useState(false);

  // 적립금 현황
  const [pointTxs,      setPointTxs]      = useState([]);
  const [pointTxTotal,  setPointTxTotal]  = useState(0);
  const [pointTxPage,   setPointTxPage]   = useState(0);
  const [pointTxFilter, setPointTxFilter] = useState(null);
  const [pointTxLoading,setPointTxLoading]= useState(false);
  const [pointSummary,  setPointSummary]  = useState(null);
  // 적립금 지급 폼
  const [grantEmail,    setGrantEmail]    = useState('');
  const [grantAmount,   setGrantAmount]   = useState('');
  const [grantDesc,     setGrantDesc]     = useState('');
  const [grantSaving,   setGrantSaving]   = useState(false);
  const [grantMsg,      setGrantMsg]      = useState(null); // {type:'ok'|'err', text}

  /* 기존 세션 확인 */
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setAuth(true);
    });
  }, []);

  const origin = window.location.origin;

  /* ── 로그인 ── */
  const MAX_TRIES   = 5;
  const LOCK_MS     = 10 * 60 * 1000; // 10분

  const doLogin = async (e) => {
    e.preventDefault();
    setLoginErr("");

    // 잠금 상태 확인
    if (loginLocked) {
      const remaining = Math.ceil((lockUntil - Date.now()) / 1000 / 60);
      if (Date.now() < lockUntil) {
        setLoginErr(`로그인 시도가 너무 많습니다. ${remaining}분 후 다시 시도하세요.`);
        return;
      }
      // 잠금 해제
      setLoginLocked(false);
      setLoginTries(0);
    }

    const { error } = await supabase.auth.signInWithPassword({
      email:    loginUser,
      password: loginPass,
    });

    if (error) {
      const newTries = loginTries + 1;
      setLoginTries(newTries);
      if (newTries >= MAX_TRIES) {
        const until = Date.now() + LOCK_MS;
        setLoginLocked(true);
        setLockUntil(until);
        setLoginErr("로그인 시도 횟수를 초과했습니다. 10분 후 다시 시도하세요.");
      } else {
        setLoginErr(`이메일 또는 비밀번호가 올바르지 않습니다. (${newTries}/${MAX_TRIES})`);
      }
    } else {
      setLoginTries(0);
      setAuth(true);
    }
  };

  /* ── 폼 초기값 ── */
  const blankForm = () => ({
    id: Date.now(), slug: "", name: "", cat: "Top", subcat: "", price: 0, discountRate: 0, shippingFee: 0, tag: "",
    sizes: ["S","M","L"], desc: "", fabric: "", origin: "Made in Korea",
    fit: "", naverUrl: "https://smartstore.naver.com/your-store", naverUrlVisible: false,
    fabricCare: "", fitSizing: "", shippingReturns: "",
    imgs: [null,null,null,null],
    galleryImgs: [null,null,null,null],
    defaultColorIdx: 0,
    colors: [],
    sizeGuideImg: null,
  });

  const startEdit = (p) => {
    setForm({
      ...p,
      imgs: p.imgs || [null,null,null,null],
      galleryImgs: p.galleryImgs || [null,null,null,null],
      defaultColorIdx: p.defaultColorIdx ?? 0,
      fabricCare: p.fabricCare ?? `소재: ${p.fabric || ""}\n원산지: ${p.origin || ""}\n\n세탁 시 30°C 이하 찬물 세탁, 드라이 클리닝 불가. 표백제 사용 금지.`,
      fitSizing: p.fitSizing ?? `핏: ${p.fit || ""}\n\n모델 신장 182cm, M 사이즈 착용 기준.\n넉넉한 핏을 원하시면 한 사이즈 업을 권장합니다.`,
      shippingReturns: p.shippingReturns ?? "무료 배송 기준: ₩100,000 이상\n배송 기간: 2–3 영업일\n교환 / 반품: 수령 후 7일 이내 가능",
      discountRate: p.discountRate ?? 0,
      shippingFee:  p.shippingFee ?? 0,
      sizeGuideImg: p.sizeGuideImg || null,
      colors: (p.colors || []).map(c => ({
        ...c,
        imgs: c.imgs || [null,null,null,null],
        galleryImgs: c.galleryImgs || [null,null,null,null],
      })),
    });
    setView("edit");
  };
  const startAdd  = ()  => { setForm(blankForm()); setView("add"); };

  /* ── 저장 ── */
  const saveProduct = async () => {
    setSaving(true);
    try {
      const f = { ...form, price: parseInt(form.price) || 0, discountRate: parseInt(form.discountRate) || 0, shippingFee: parseInt(form.shippingFee) || 0, slug: form.slug || toSlug(form.name) };
      await apiSave(f, view);
      await onProductsChange();
      setView("list");
    } catch (err) {
      alert("저장 중 오류가 발생했습니다: " + (err.message || JSON.stringify(err)));
    } finally {
      setSaving(false);
    }
  };

  /* ── 삭제 ── */
  const deleteProduct = async (id) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    try {
      await apiDelete(id);
      await onProductsChange();
    } catch (err) {
      alert("삭제 중 오류가 발생했습니다: " + err.message);
    }
  };

  /* ── 노출 순서 설정 ── */
  const openOrder = () => {
    setOrderForm([...products]);
    setView("order");
  };

  const doSaveOrder = async () => {
    setOrderSaving(true);
    try {
      await saveProductOrder(orderForm.map(p => p.id));
      await onProductsChange();
      setView("list");
    } catch (err) {
      alert("순서 저장 실패: " + err.message);
    } finally {
      setOrderSaving(false);
    }
  };

  const onDragStart = (e, idx) => {
    setDragIdx(idx);
    e.dataTransfer.effectAllowed = "move";
  };

  const onDragOver = (e, idx) => {
    e.preventDefault();
    if (dragIdx === null || dragIdx === idx) return;
    const next = [...orderForm];
    const [item] = next.splice(dragIdx, 1);
    next.splice(idx, 0, item);
    setOrderForm(next);
    setDragIdx(idx);
  };

  const onDragEnd = () => setDragIdx(null);

  /* ── 이미지 업로드 ── */
  const handleImg = (idx, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setForm(prev => {
        const imgs = [...(prev.imgs || [null,null,null,null])];
        imgs[idx] = e.target.result;
        return { ...prev, imgs };
      });
    };
    reader.readAsDataURL(file);
  };

  const handleGalleryImg = (idx, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setForm(prev => {
        const galleryImgs = [...(prev.galleryImgs || [null,null,null,null])];
        galleryImgs[idx] = e.target.result;
        return { ...prev, galleryImgs };
      });
    };
    reader.readAsDataURL(file);
  };

  /* ── 컬러 관리 ── */
  const addColor = () => setForm(p => ({
    ...p,
    colors: [...(p.colors || []), { name: "", hex: "#1A1A1A", imgs: [null,null,null,null], galleryImgs: [null,null,null,null] }],
  }));

  const removeColor = (ci) => setForm(p => ({
    ...p,
    colors: p.colors.filter((_, i) => i !== ci),
    defaultColorIdx: p.defaultColorIdx >= ci && p.defaultColorIdx > 0 ? p.defaultColorIdx - 1 : p.defaultColorIdx,
  }));

  const updateColor = (ci, key, val) => setForm(p => ({
    ...p, colors: p.colors.map((c, i) => i === ci ? { ...c, [key]: val } : c),
  }));

  const handleColorImg = (ci, idx, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setForm(prev => ({
        ...prev,
        colors: prev.colors.map((c, i) => {
          if (i !== ci) return c;
          const imgs = [...(c.imgs || [null,null,null,null])];
          imgs[idx] = e.target.result;
          return { ...c, imgs };
        }),
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleColorGalleryImg = (ci, idx, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      setForm(prev => ({
        ...prev,
        colors: prev.colors.map((c, i) => {
          if (i !== ci) return c;
          const galleryImgs = [...(c.galleryImgs || [null,null,null,null])];
          galleryImgs[idx] = e.target.result;
          return { ...c, galleryImgs };
        }),
      }));
    };
    reader.readAsDataURL(file);
  };

  /* ── 이미지 삭제 ── */
  const handleRemoveImg = (idx) => setForm(prev => {
    const imgs = [...(prev.imgs || [])]; imgs[idx] = null; return { ...prev, imgs };
  });
  const handleRemoveGalleryImg = (idx) => setForm(prev => {
    const galleryImgs = [...(prev.galleryImgs || [])]; galleryImgs.splice(idx, 1); return { ...prev, galleryImgs };
  });
  const handleRemoveColorImg = (ci, idx) => setForm(prev => ({
    ...prev,
    colors: prev.colors.map((c, i) => {
      if (i !== ci) return c;
      const imgs = [...(c.imgs || [])]; imgs.splice(idx, 1); return { ...c, imgs };
    }),
  }));
  const handleRemoveColorGalleryImg = (ci, idx) => setForm(prev => ({
    ...prev,
    colors: prev.colors.map((c, i) => {
      if (i !== ci) return c;
      const galleryImgs = [...(c.galleryImgs || [])]; galleryImgs.splice(idx, 1); return { ...c, galleryImgs };
    }),
  }));

  /* ── 사이즈 토글 ── */
  const toggleSize = (sz) => setForm(prev => ({
    ...prev,
    sizes: prev.sizes.includes(sz) ? prev.sizes.filter(s => s !== sz) : [...prev.sizes, sz],
  }));

  /* ── 메뉴 설정 ── */
  const openNav = async () => {
    const [cats, menu] = await Promise.all([fetchNavCats(), fetchMainMenu()]);
    setNavForm(JSON.parse(JSON.stringify(cats)));
    setMainMenuForm(JSON.parse(JSON.stringify(menu)));
    setView("nav");
  };

  /* ── 전체 메뉴 핸들러 ── */
  const MENU_TYPE_OPTIONS = [
    { value: "shop",     label: "Shop (드롭다운)" },
    { value: "shop_all", label: "모든 제품 (전체 보기)" },
    { value: "new",      label: "New In" },
    { value: "best",     label: "Best Sellers" },
    { value: "about",    label: "About" },
    { value: "board",    label: "고객센터" },
  ];
  const updateMainMenuItem  = (idx, key, val) => setMainMenuForm(f => f.map((m, i) => i === idx ? { ...m, [key]: val } : m));
  const removeMainMenuItem  = (idx) => setMainMenuForm(f => f.filter((_, i) => i !== idx));
  const moveMainMenuItem    = (idx, dir) => setMainMenuForm(f => {
    const next = [...f];
    const target = idx + dir;
    if (target < 0 || target >= next.length) return f;
    [next[idx], next[target]] = [next[target], next[idx]];
    return next;
  });
  const addMainMenuItem = () => setMainMenuForm(f => [...f, { id: `item_${Date.now()}`, label: "새 항목", type: "new", visible: true }]);
  const doSaveMainMenu = async () => {
    setMainMenuSaving(true);
    try {
      await saveMainMenu(mainMenuForm);
      onMainMenuChange(mainMenuForm);
      alert("상단 메뉴가 저장됐습니다.");
    } catch (err) {
      alert("오류: " + err.message);
    } finally {
      setMainMenuSaving(false);
    }
  };;
  const updateNavCat  = (ci, key, val) => setNavForm(f => f.map((c, i) => i === ci ? { ...c, [key]: val } : c));
  const removeNavCat  = (ci)           => setNavForm(f => f.filter((_, i) => i !== ci));
  const addNavCat     = ()             => setNavForm(f => [...f, { title: "NEW", catFilter: "Top", items: [] }]);
  const updateNavItem = (ci, ii, key, val) => setNavForm(f => f.map((c, i) => i === ci ? {
    ...c,
    items: c.items.map((it, j) => {
      if (j !== ii) return it;
      const obj = typeof it === "string" ? { label: it, filter: it } : it;
      return { ...obj, [key]: val };
    }),
  } : c));
  const removeNavItem = (ci, ii)       => setNavForm(f => f.map((c, i) => i === ci ? { ...c, items: c.items.filter((_, j) => j !== ii) } : c));
  const addNavItem    = (ci)           => setNavForm(f => f.map((c, i) => i === ci ? { ...c, items: [...c.items, { label: "", filter: "" }] } : c));
  const doSaveNav = async () => {
    setNavSaving(true);
    try {
      await saveNavCats(navForm);
      onNavCatsChange(navForm);
      alert("메뉴가 저장됐습니다.");
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setNavSaving(false);
    }
  };

  /* ── 히어로 슬라이드 관리 ── */
  const openSlides = () => {
    setSlidesForm(JSON.parse(JSON.stringify(slidesProp || [])));
    setView("slides");
  };

  const updateSlide = (si, key, val) =>
    setSlidesForm(f => f.map((s, i) => i === si ? { ...s, [key]: val } : s));

  const addSlide = () =>
    setSlidesForm(f => [...f, { id: Date.now(), img: null, label: "NEW SLIDE", sub: "" }]);

  const removeSlide = (si) =>
    setSlidesForm(f => f.filter((_, i) => i !== si));

  const handleSlideImg = (si, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) =>
      setSlidesForm(prev => prev.map((s, i) => i === si ? { ...s, img: e.target.result } : s));
    reader.readAsDataURL(file);
  };

  const doSaveSlides = async () => {
    setSlidesSaving(true);
    try {
      const updated = await saveSlides(slidesForm);
      onSlidesChange(updated);
      alert("슬라이드가 저장됐습니다.");
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setSlidesSaving(false);
    }
  };

  /* ── 사이트 설정 관리 ── */
  const openSiteSettings = () => {
    const merged = { ...DEFAULT_SITE_SETTINGS, ...JSON.parse(JSON.stringify(siteSettingsProp || {})) };
    if (!merged.footerLinks) merged.footerLinks = DEFAULT_SITE_SETTINGS.footerLinks;
    setSiteSettingsForm(merged);
    setView("siteSettings");
  };

  const doSaveSiteSettings = async () => {
    setSiteSettingsSaving(true);
    try {
      const saved = await saveSiteSettings(siteSettingsForm);
      onSiteSettingsChange(saved);
      setSiteSettingsForm(saved);
      alert("저장되었습니다.");
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setSiteSettingsSaving(false);
    }
  };

  const setSS = (key, val) => setSiteSettingsForm(f => ({ ...f, [key]: val }));
  const setEB = (key, val) => setSiteSettingsForm(f => ({ ...f, eventBanner: { ...f.eventBanner, [key]: val } }));
  const setCB = (key, val) => setSiteSettingsForm(f => ({ ...f, couponBanner: { ...f.couponBanner, [key]: val } }));
  const setPM = (key, val) => setSiteSettingsForm(f => ({ ...f, paymentMethods: { ...(f.paymentMethods || {}), [key]: val } }));
  const setFL = (section, idx, field, val) => setSiteSettingsForm(f => ({
    ...f,
    footerLinks: {
      ...(f.footerLinks || {}),
      [section]: ((f.footerLinks || {})[section] || []).map((item, i) =>
        i === idx ? { ...item, [field]: val } : item
      ),
    },
  }));

  /* ── Info 페이지 콘텐츠 관리 ── */
  const INFO_TYPES = [
    { key: "contact",    label: "Contact" },
    { key: "faq",        label: "FAQ" },
    { key: "returns",    label: "Returns" },
    { key: "shipping",   label: "Shipping" },
    { key: "stockist",   label: "Stockist" },
    { key: "recruit",    label: "Recruit" },
    { key: "membership", label: "Membership" },
  ];

  const openInfoContent = () => {
    const base = JSON.parse(JSON.stringify(infoContentProp || DEFAULT_INFO_CONTENT));
    setInfoContentForm(base);
    setInfoEditType("contact");
    setView("infoContent");
  };

  const updateInfoMeta = (field, val) => setInfoContentForm(f => ({
    ...f,
    [infoEditType]: { ...f[infoEditType], [field]: val },
  }));

  const updateInfoSect = (si, field, val) => setInfoContentForm(f => ({
    ...f,
    [infoEditType]: {
      ...f[infoEditType],
      sections: f[infoEditType].sections.map((s, i) => i === si ? { ...s, [field]: val } : s),
    },
  }));

  const addInfoSect = () => setInfoContentForm(f => ({
    ...f,
    [infoEditType]: {
      ...f[infoEditType],
      sections: [...(f[infoEditType].sections || []), { heading: "", body: "" }],
    },
  }));

  const removeInfoSect = (si) => setInfoContentForm(f => ({
    ...f,
    [infoEditType]: {
      ...f[infoEditType],
      sections: f[infoEditType].sections.filter((_, i) => i !== si),
    },
  }));

  const doSaveInfoContent = async () => {
    setInfoContentSaving(true);
    try {
      const saved = await apiSaveInfoContent(infoContentForm);
      onInfoContentChange(saved);
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setInfoContentSaving(false);
    }
  };

  /* ── 브랜드 이미지 관리 ── */
  const openBrand = () => {
    const def = {
      brandStrip: null,
      aboutHero: null,
      collections: [
        { img: null, label: "TRAINING" },
        { img: null, label: "PERFORMANCE" },
        { img: null, label: "ESSENTIALS" },
      ],
    };
    setBrandForm(JSON.parse(JSON.stringify(brandImagesProp || def)));
    setView("brand");
  };

  const handleBrandSingleImg = (key, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => setBrandForm(prev => ({ ...prev, [key]: e.target.result }));
    reader.readAsDataURL(file);
  };

  const handleBrandCollectionImg = (idx, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => setBrandForm(prev => {
      const collections = [...(prev.collections || [])];
      collections[idx] = { ...(collections[idx] || {}), img: e.target.result };
      return { ...prev, collections };
    });
    reader.readAsDataURL(file);
  };

  const updateCollectionLabel = (idx, label) => setBrandForm(prev => {
    const collections = [...(prev.collections || [])];
    collections[idx] = { ...(collections[idx] || {}), label };
    return { ...prev, collections };
  });

  const doSaveBrand = async () => {
    setBrandSaving(true);
    try {
      const updated = await saveBrandImages(brandForm);
      onBrandImagesChange(updated);
      alert("브랜드 이미지가 저장됐습니다.");
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setBrandSaving(false);
    }
  };

  /* ── 주문 관리 ── */
  const openOrders = async () => {
    setView("orders");
    setOrdersLoading(true);
    const { data } = await supabase
      .from("orders")
      .select("*")
      .order("created_at", { ascending: false });
    setAllOrders(data || []);
    setOrdersLoading(false);
  };

  const updateOrderStatus = async (orderId, newStatus) => {
    setStatusSaving(orderId);
    const { error } = await supabase.from("orders").update({ status: newStatus }).eq("id", orderId);
    if (error) {
      alert("상태 변경 실패: " + error.message);
      setStatusSaving(null);
      return;
    }
    setAllOrders(prev => prev.map(o => o.id === orderId ? { ...o, status: newStatus } : o));
    setStatusSaving(null);
  };

  /* ── 쿠폰 관리 ── */
  const blankCoupon = () => ({
    id: null, title: "", code: "", type: "percent", value: 10, maxDiscount: "",
    minOrderAmount: 0, usageLimitPerUser: 1, startsAt: "", expiresAt: "",
    isWelcome: false, welcomeExpiresDays: "", active: true,
  });

  const openCoupons = async () => {
    setView("coupons");
    setCouponsLoading(true);
    try {
      setCoupons(await fetchCoupons());
    } finally {
      setCouponsLoading(false);
    }
  };

  const startAddCoupon = () => { setCouponForm(blankCoupon()); setView("coupon-edit"); };
  const startEditCoupon = (c) => {
    setCouponForm({
      id: c.id, title: c.title, code: c.code || "", type: c.type, value: c.value,
      maxDiscount: c.max_discount ?? "", minOrderAmount: c.min_order_amount,
      usageLimitPerUser: c.usage_limit_per_user,
      startsAt: c.starts_at ? c.starts_at.slice(0, 10) : "",
      expiresAt: c.expires_at ? c.expires_at.slice(0, 10) : "",
      isWelcome: c.is_welcome, welcomeExpiresDays: c.welcome_expires_days ?? "", active: c.active,
    });
    setView("coupon-edit");
  };

  const doSaveCoupon = async () => {
    setCouponSaving(true);
    try {
      await apiSaveCoupon(couponForm);
      setCoupons(await fetchCoupons());
      setView("coupons");
    } catch (err) {
      alert("저장 실패: " + err.message);
    } finally {
      setCouponSaving(false);
    }
  };

  const doDeleteCoupon = async (id) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) return;
    try {
      await apiDeleteCoupon(id);
      setCoupons(await fetchCoupons());
    } catch (err) {
      alert("삭제 실패: " + err.message);
    }
  };

  const openIssuePanel = (couponId) => {
    setIssuePanelFor(couponId);
    setUserQuery(""); setUserResults([]); setSelectedUsers([]);
  };

  const doSearchUsers = async (q) => {
    setUserQuery(q);
    if (!q.trim()) { setUserResults([]); return; }
    try {
      setUserResults(await searchProfiles(q));
    } catch {
      setUserResults([]);
    }
  };

  const toggleSelectedUser = (id) => setSelectedUsers(prev =>
    prev.includes(id) ? prev.filter(u => u !== id) : [...prev, id]);

  const doIssueCoupon = async () => {
    if (!selectedUsers.length) return;
    setIssuing(true);
    try {
      await issueCouponToUsers(issuePanelFor, selectedUsers);
      alert(`${selectedUsers.length}명에게 쿠폰을 발급했습니다.`);
      setIssuePanelFor(null);
    } catch (err) {
      alert("발급 실패: " + err.message);
    } finally {
      setIssuing(false);
    }
  };

  /* ── URL 복사 ── */
  const copyUrl = (slug) => {
    navigator.clipboard.writeText(`${origin}/product/${slug}`).then(() => {
      setCopied(slug); setTimeout(() => setCopied(null), 1500);
    });
  };

  /* ══════════════
     로그인 화면
  ══════════════ */
  if (!auth) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:"#F0F0EE" }}>
      <div style={{ width:360, background:"#fff", border:"1px solid #E0E0DE", borderRadius:6, padding:"48px 40px", boxShadow:"0 4px 24px rgba(0,0,0,.06)" }}>
        <p style={{ fontFamily:"'DM Serif Display',serif", fontSize:15, letterSpacing:3, textAlign:"center", marginBottom:6, color:C.ink }}>UNDERLOOKED</p>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:4, textAlign:"center", color:C.muted, marginBottom:36, textTransform:"uppercase" }}>Admin</p>
        <form onSubmit={doLogin} style={{ display:"flex", flexDirection:"column", gap:14 }}>
          <AdmInput label="아이디" type="text" value={loginUser} onChange={e => setLoginUser(e.target.value)} autoComplete="username" />
          <AdmInput label="비밀번호" type="password" value={loginPass} onChange={e => setLoginPass(e.target.value)} autoComplete="current-password" />
          {loginErr && <p style={{ fontSize:12, color:"#C0392B", lineHeight:1.6 }}>{loginErr}</p>}
          <button className="adm-btn" type="submit"
            disabled={loginLocked && Date.now() < lockUntil}
            style={{ background: (loginLocked && Date.now() < lockUntil) ? "#AAA" : C.ink, color:"#fff", marginTop:8, cursor: (loginLocked && Date.now() < lockUntil) ? "not-allowed" : "pointer" }}>
            로그인
          </button>
        </form>
      </div>
    </div>
  );

  /* ══════════════
     사이드바 (고정)
  ══════════════ */
  const openAdminNotices = async () => {
    setView("admin-notices");
    setNoticeEditMode(false);
    setNoticeForm({ id: null, title: '', content: '', imageUrl: '' });
    const { data } = await supabase.from('notices').select('*').order('created_at', { ascending: false });
    setAdminNotices(data || []);
  };

  const openAdminInquiries = async () => {
    setView("admin-inquiries");
    setSelectedInquiry(null);
    const { data } = await supabase.from('inquiries').select('*').order('created_at', { ascending: false });
    setAdminInquiries(data || []);
  };

  const openMembers = async () => {
    setView("members");
    setMembersLoading(true);
    const { data } = await supabase.from('profiles').select('id,username,name,email,provider,created_at,is_admin').order('created_at', { ascending: false });
    setMembers(data || []);
    setMembersLoading(false);
  };

  const uploadNoticeImage = async (file) => {
    if (!file) return;
    setNoticeImgUploading(true);
    const ext = file.name.split('.').pop();
    const path = `notices/${Date.now()}.${ext}`;
    const { error } = await supabase.storage.from('product-images').upload(path, file, { upsert: true });
    if (!error) {
      const { data: urlData } = supabase.storage.from('product-images').getPublicUrl(path);
      setNoticeForm(f => ({ ...f, imageUrl: urlData.publicUrl }));
    }
    setNoticeImgUploading(false);
  };

  const saveNotice = async (e) => {
    e.preventDefault();
    if (!noticeForm.title.trim() || !noticeForm.content.trim()) return;
    setNoticeSaving(true);
    const payload = {
      title: noticeForm.title.trim(),
      content: noticeForm.content.trim(),
      image_url: noticeForm.imageUrl || null,
      updated_at: new Date().toISOString(),
    };
    if (noticeForm.id) {
      await supabase.from('notices').update(payload).eq('id', noticeForm.id);
    } else {
      await supabase.from('notices').insert(payload);
    }
    const { data } = await supabase.from('notices').select('*').order('created_at', { ascending: false });
    setAdminNotices(data || []);
    setNoticeForm({ id: null, title: '', content: '', imageUrl: '' });
    setNoticeEditMode(false);
    setNoticeSaving(false);
  };

  const deleteNotice = async (id) => {
    if (!window.confirm('공지사항을 삭제하시겠습니까?')) return;
    await supabase.from('notices').delete().eq('id', id);
    setAdminNotices(prev => prev.filter(n => n.id !== id));
  };

  const openInquiryDetail = async (inq) => {
    setSelectedInquiry(inq);
    const { data } = await supabase.from('inquiry_replies').select('*').eq('inquiry_id', inq.id).order('created_at');
    setInquiryReplies(prev => ({ ...prev, [inq.id]: data || [] }));
    setReplyContent('');
  };

  const submitReply = async () => {
    if (!replyContent.trim() || !selectedInquiry) return;
    setReplySaving(true);
    await supabase.from('inquiry_replies').insert({ inquiry_id: selectedInquiry.id, content: replyContent.trim() });
    await supabase.from('inquiries').update({ status: 'answered' }).eq('id', selectedInquiry.id);
    const { data } = await supabase.from('inquiry_replies').select('*').eq('inquiry_id', selectedInquiry.id).order('created_at');
    setInquiryReplies(prev => ({ ...prev, [selectedInquiry.id]: data || [] }));
    setSelectedInquiry(prev => ({ ...prev, status: 'answered' }));
    setAdminInquiries(prev => prev.map(i => i.id === selectedInquiry.id ? { ...i, status: 'answered' } : i));
    setReplyContent('');
    setReplySaving(false);
  };

  const deleteReply = async (replyId, inqId) => {
    if (!window.confirm('답변을 삭제하시겠습니까?')) return;
    await supabase.from('inquiry_replies').delete().eq('id', replyId);
    const remaining = (inquiryReplies[inqId] || []).filter(r => r.id !== replyId);
    setInquiryReplies(prev => ({ ...prev, [inqId]: remaining }));
    if (remaining.length === 0) {
      await supabase.from('inquiries').update({ status: 'pending' }).eq('id', inqId);
      setAdminInquiries(prev => prev.map(i => i.id === inqId ? { ...i, status: 'pending' } : i));
      setSelectedInquiry(prev => prev?.id === inqId ? { ...prev, status: 'pending' } : prev);
    }
  };

  const deleteInquiry = async (id) => {
    if (!window.confirm('문의를 삭제하시겠습니까?\n답변도 함께 삭제됩니다.')) return;
    await supabase.from('inquiry_replies').delete().eq('inquiry_id', id);
    await supabase.from('inquiries').delete().eq('id', id);
    setAdminInquiries(prev => prev.filter(i => i.id !== id));
    setSelectedInquiry(null);
  };

  /* ── 리뷰 관리 ── */
  const REVIEW_PAGE_SIZE = 20;

  const openAdminReviews = async (page = 0, filter = 'all') => {
    setView("admin-reviews");
    setSelectedReview(null);
    setAdminReviewLoading(true);
    setAdminReviewPage(page);
    setReviewListFilter(filter);
    try {
      let q = supabase
        .from('reviews')
        .select('*', { count: 'exact' })
        .order('created_at', { ascending: false })
        .range(page * REVIEW_PAGE_SIZE, (page + 1) * REVIEW_PAGE_SIZE - 1);
      if (filter === 'best') q = q.eq('is_best', true);
      if (filter === 'pending') q = q.eq('photo_points_pending', true);
      const { data, error, count } = await q;
      if (error) throw error;

      // 프로필 배치 조회 (reviews.user_id → auth.users이라 직접 조인 불가)
      const userIds = [...new Set((data || []).map(r => r.user_id).filter(Boolean))];
      let profileMap = {};
      if (userIds.length) {
        const { data: profiles } = await supabase
          .from('profiles')
          .select('id, name, username')
          .in('id', userIds);
        (profiles || []).forEach(p => { profileMap[p.id] = p; });
      }

      setAdminReviews((data || []).map(r => ({ ...r, profiles: profileMap[r.user_id] || null })));
      setAdminReviewTotal(count ?? 0);
    } catch (err) {
      alert('리뷰를 불러오는 중 오류가 발생했습니다: ' + err.message);
    } finally {
      setAdminReviewLoading(false);
    }
  };

  const openReviewDetail = async (review) => {
    setSelectedReview(review);
    setReviewCommentText('');
    if (!reviewCommentMap[review.id]) {
      const comments = await fetchReviewComments(review.id).catch(() => []);
      setReviewCommentMap(prev => ({ ...prev, [review.id]: comments }));
    }
  };

  const submitReviewComment = async () => {
    if (!reviewCommentText.trim() || !selectedReview) return;
    setReviewCommentSaving(true);
    try {
      await addReviewComment(selectedReview.id, reviewCommentText.trim());
      const comments = await fetchReviewComments(selectedReview.id);
      setReviewCommentMap(prev => ({ ...prev, [selectedReview.id]: comments }));
      setReviewCommentText('');
    } catch (err) {
      alert('댓글 등록 실패: ' + err.message);
    } finally {
      setReviewCommentSaving(false);
    }
  };

  const removeReviewComment = async (commentId) => {
    if (!window.confirm('댓글을 삭제하시겠습니까?')) return;
    await deleteReviewComment(commentId);
    setReviewCommentMap(prev => ({
      ...prev,
      [selectedReview.id]: (prev[selectedReview.id] || []).filter(c => c.id !== commentId),
    }));
  };

  const doDeleteReview = async (reviewId) => {
    if (!window.confirm('리뷰를 삭제하시겠습니까?\n댓글도 함께 삭제됩니다.')) return;
    await supabase.from('reviews').delete().eq('id', reviewId);
    setAdminReviews(prev => prev.filter(r => r.id !== reviewId));
    setAdminReviewTotal(prev => prev - 1);
    setSelectedReview(null);
  };

  const doToggleBestInManage = async (review) => {
    setBestSaving(review.id);
    try {
      await setBestReview(review.id, !review.is_best);
      setAdminReviews(prev => prev.map(r => r.id === review.id ? { ...r, is_best: !r.is_best } : r));
      if (selectedReview?.id === review.id) setSelectedReview(prev => ({ ...prev, is_best: !prev.is_best }));
    } catch (err) {
      alert('오류: ' + err.message);
    } finally {
      setBestSaving(null);
    }
  };

  const doGrantPhotoPoints = async (reviewId) => {
    if (!window.confirm('이 리뷰에 적립금을 지급하시겠습니까?')) return;
    try {
      await grantPhotoReviewPoints(reviewId);
      const update = { points_granted: true, photo_points_pending: false };
      setAdminReviews(prev => prev.map(r => r.id === reviewId ? { ...r, ...update } : r));
      if (selectedReview?.id === reviewId) setSelectedReview(prev => ({ ...prev, ...update }));
      alert('적립금이 지급됐습니다.');
    } catch (err) {
      alert('지급 실패: ' + err.message);
    }
  };

  /* ── 적립금 현황 ── */
  const POINTS_PAGE_SIZE = 30;
  const POINT_TYPE_OPTS = [
    { value: null,           label: "전체" },
    { value: "earn_review",  label: "리뷰 적립" },
    { value: "earn_best",    label: "BEST 리뷰" },
    { value: "spend_order",  label: "주문 사용" },
    { value: "expire",       label: "소멸" },
    { value: "admin",        label: "관리자 지급" },
  ];

  const openPointsAdmin = async (page = 0, type = null) => {
    setView("points-admin");
    setPointTxPage(page);
    setPointTxFilter(type);
    setPointTxLoading(true);
    try {
      const [txResult, summary] = await Promise.all([
        fetchAllPointTransactions({ page, pageSize: POINTS_PAGE_SIZE, type }),
        page === 0 ? fetchPointSummary() : Promise.resolve(null),
      ]);
      setPointTxs(txResult.transactions);
      setPointTxTotal(txResult.total);
      if (summary) setPointSummary(summary);
    } catch (err) {
      alert('불러오기 실패: ' + err.message);
    } finally {
      setPointTxLoading(false);
    }
  };

  const handleAdminGrantPoints = async (e) => {
    e.preventDefault();
    const amt = parseInt(grantAmount, 10);
    if (!grantEmail.trim() || !amt || !grantDesc.trim()) return;
    setGrantSaving(true);
    setGrantMsg(null);
    try {
      // 이메일로 사용자 조회
      const { data: profile, error: pErr } = await supabase
        .from('profiles').select('id,name').eq('email', grantEmail.trim()).single();
      if (pErr || !profile) throw new Error('이메일에 해당하는 회원을 찾을 수 없습니다');
      await adminGrantPoints(profile.id, amt, grantDesc.trim());
      setGrantMsg({ type: 'ok', text: `${profile.name || grantEmail}에게 ₩${amt.toLocaleString()} 지급 완료` });
      setGrantEmail(''); setGrantAmount(''); setGrantDesc('');
      openPointsAdmin(0, pointTxFilter);
    } catch (err) {
      setGrantMsg({ type: 'err', text: err.message });
    } finally {
      setGrantSaving(false);
    }
  };

  const handleDeletePointTx = async (txId) => {
    if (!window.confirm('이 적립금 내역을 삭제하시겠습니까?\n삭제하면 해당 금액이 즉시 반영됩니다.')) return;
    try {
      await adminDeletePointTransaction(txId);
      setPointTxs(prev => prev.filter(t => t.id !== txId));
      openPointsAdmin(pointTxPage, pointTxFilter);
    } catch (err) {
      alert('삭제 실패: ' + err.message);
    }
  };

  const providerBadge = (p) => {
    if (p === 'naver')  return { label:'N', bg:'#03C75A', color:'#fff' };
    if (p === 'kakao')  return { label:'K', bg:'#FEE500', color:'#000' };
    return { label:'E', bg:'#E8E8E6', color:'#666' };
  };

  const fmtDate = (ts) => ts ? new Date(ts).toLocaleString('ko-KR', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' }) : '-';

  /* ── 재고 관리 ── */
  const openInventory = async (productId) => {
    if (!productId) { setInventoryProduct(null); setInventoryRows([]); return; }
    setInventoryProduct(productId);
    setView("inventory");
    setInventoryLoading(true);
    const rows = await fetchInventory(productId).catch(() => []);
    setInventoryRows(rows);
    setInventoryLoading(false);
    setInventoryForm({ size: '', color_name: '', quantity: 0 });
  };

  const doUpsertInventory = async () => {
    if (!inventoryForm.size || !inventoryProduct) return;
    setInventoryLoading(true);
    await upsertInventoryRow({ ...inventoryForm, product_id: inventoryProduct, quantity: parseInt(inventoryForm.quantity) || 0 });
    const rows = await fetchInventory(inventoryProduct).catch(() => []);
    setInventoryRows(rows);
    setInventoryLoading(false);
  };

  const doDeleteInventory = async (id) => {
    await deleteInventoryRow(id);
    setInventoryRows(prev => prev.filter(r => r.id !== id));
  };

  /* ── 베스트 리뷰 ── */
  const openBestReviews = async () => {
    setView("best-reviews");
    setReviewsLoading(true);
    const { reviews } = await fetchAllReviews().catch(() => ({ reviews: [] }));
    setAllReviews(reviews);
    setReviewsLoading(false);
  };

  const doToggleBest = async (review) => {
    setBestSaving(review.id);
    try {
      await setBestReview(review.id, !review.is_best);
      setAllReviews(prev => prev.map(r => r.id === review.id ? { ...r, is_best: !r.is_best } : r));
    } catch (err) {
      alert("오류: " + err.message);
    } finally {
      setBestSaving(null);
    }
  };

  const NAV_SECTIONS = [
    { group: "커머스", items: [
      { label: "제품 관리",   views: ["list","edit","add"],    action: () => setView("list") },
      { label: "주문 관리",   views: ["orders"],               action: openOrders },
      { label: "쿠폰 관리",   views: ["coupons","coupon-edit"], action: openCoupons },
      { label: "재고 관리",   views: ["inventory"],            action: () => { setView("inventory"); setInventoryProduct(null); setInventoryRows([]); } },
      { label: "베스트 리뷰", views: ["best-reviews"],         action: openBestReviews },
    ]},
    { group: "게시판", items: [
      { label: "공지사항",   views: ["admin-notices"],    action: openAdminNotices },
      { label: "문의 관리",  views: ["admin-inquiries"],  action: openAdminInquiries },
      { label: "리뷰 관리",  views: ["admin-reviews"],    action: openAdminReviews },
    ]},
    { group: "회원", items: [
      { label: "회원 목록",   views: ["members"],          action: openMembers },
      { label: "적립금 현황", views: ["points-admin"],     action: () => openPointsAdmin(0, null) },
    ]},
    { group: "사이트", items: [
      { label: "사이트 설정",    views: ["siteSettings"],  action: openSiteSettings },
      { label: "Info 페이지",    views: ["infoContent"],   action: openInfoContent },
      { label: "히어로 슬라이드", views: ["slides"],        action: openSlides },
      { label: "브랜드 이미지",   views: ["brand"],         action: openBrand },
      { label: "전체 메뉴 관리",   views: ["nav"],           action: openNav },
      { label: "노출 순서",      views: ["order"],         action: openOrder },
    ]},
  ];

  const AdminHeader = () => (
    <div style={{ position:"fixed", left:0, top:0, bottom:0, width:220, background:"#1A1A1A", zIndex:200, display:"flex", flexDirection:"column", overflowY:"auto" }}>
      {/* 로고 */}
      <div style={{ padding:"28px 20px 16px", flexShrink:0 }}>
        <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:13, letterSpacing:3, color:"#F2F1ED" }}>UNDERLOOKED</div>
        <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:8, letterSpacing:3, color:"rgba(242,241,237,.3)", marginTop:5, textTransform:"uppercase" }}>Admin Console</div>
      </div>

      {/* 네비게이션 */}
      <nav style={{ flex:1 }}>
        {NAV_SECTIONS.map(sec => (
          <div key={sec.group}>
            <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:8, letterSpacing:3, color:"rgba(242,241,237,.28)", padding:"14px 20px 5px", textTransform:"uppercase" }}>
              {sec.group}
            </div>
            {sec.items.map(item => {
              const active = item.views.includes(view);
              return (
                <button key={item.label} onClick={item.action}
                  style={{ display:"block", width:"100%", textAlign:"left",
                    fontFamily:"'Pretendard',sans-serif", fontSize:12,
                    padding:"9px 20px 9px 18px",
                    background: active ? "rgba(255,255,255,.07)" : "none",
                    color: active ? "#F2F1ED" : "rgba(242,241,237,.45)",
                    border:"none", cursor:"pointer",
                    borderLeft: active ? `2px solid ${C.accent}` : "2px solid transparent",
                    transition:"color .15s, background .15s",
                  }}
                  onMouseEnter={e => { if (!active) e.currentTarget.style.color="#F2F1ED"; }}
                  onMouseLeave={e => { if (!active) e.currentTarget.style.color="rgba(242,241,237,.45)"; }}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        ))}
      </nav>

      {/* 하단 */}
      <div style={{ borderTop:"1px solid rgba(255,255,255,.08)", padding:"14px 12px", flexShrink:0 }}>
        <button onClick={onGoHome}
          style={{ display:"block", width:"100%", textAlign:"left", padding:"8px 8px", fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"rgba(242,241,237,.4)", background:"none", border:"none", cursor:"pointer", transition:"color .15s" }}
          onMouseEnter={e => e.currentTarget.style.color="#F2F1ED"}
          onMouseLeave={e => e.currentTarget.style.color="rgba(242,241,237,.4)"}>
          ← 메인 사이트
        </button>
        <button onClick={async () => { await supabase.auth.signOut(); setAuth(false); setLoginUser(""); setLoginPass(""); }}
          style={{ display:"block", width:"100%", textAlign:"left", padding:"8px 8px", fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"rgba(242,241,237,.3)", background:"none", border:"none", cursor:"pointer", transition:"color .15s" }}
          onMouseEnter={e => e.currentTarget.style.color="#F2F1ED"}
          onMouseLeave={e => e.currentTarget.style.color="rgba(242,241,237,.3)"}>
          로그아웃
        </button>
      </div>
    </div>
  );

  /* ══════════════
     제품 목록
  ══════════════ */
  if (view === "list") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:28 }}>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, letterSpacing:"-0.3px" }}>제품 관리</h2>
          <button className="adm-btn" onClick={startAdd} style={{ background:C.ink, color:"#fff" }}>+ 새 제품 추가</button>
        </div>

        <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, overflow:"hidden" }}>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ borderBottom:"1px solid #F0F0EE", background:"#FAFAF8" }}>
                {["이미지","제품명","카테고리","가격","태그","URL",""].map(h => (
                  <th key={h} style={{ padding:"12px 14px", textAlign:"left", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, textTransform:"uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {products.map(p => (
                <tr key={p.id} style={{ borderBottom:"1px solid #F5F5F3" }}>
                  <td style={{ padding:"10px 14px" }}>
                    <div style={{ width:40, height:52, background:"#F0F0EE", borderRadius:3, overflow:"hidden" }}>
                      {(() => { const t = p.imgs?.[0] || p.colors?.[p.defaultColorIdx ?? 0]?.imgs?.[0]; return t
                        ? <img src={t} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="" />
                        : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18 }}>+</div>;
                      })()}
                    </div>
                  </td>
                  <td style={{ padding:"10px 14px", fontSize:14, maxWidth:180 }}>{p.name}</td>
                  <td style={{ padding:"10px 14px", fontSize:12, color:C.muted }}>{p.cat}</td>
                  <td style={{ padding:"10px 14px", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:12 }}>
                    {p.discountRate > 0 ? (
                      <span>
                        <span style={{ textDecoration:"line-through", color:"#AAA", fontSize:10, marginRight:5 }}>₩{p.price.toLocaleString()}</span>
                        <span style={{ color:"#C0392B" }}>₩{Math.round(p.price * (1 - p.discountRate / 100)).toLocaleString()}</span>
                        <span style={{ marginLeft:5, fontSize:9, background:"#C0392B", color:"#fff", padding:"1px 5px", borderRadius:2 }}>{p.discountRate}%</span>
                      </span>
                    ) : (
                      <span>₩{p.price.toLocaleString()}</span>
                    )}
                  </td>
                  <td style={{ padding:"10px 14px" }}>
                    {p.tag && <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, padding:"3px 8px", background:p.tag==="BEST"?C.ink:C.accent, color:"#fff", borderRadius:2 }}>{p.tag}</span>}
                  </td>
                  <td style={{ padding:"10px 14px", maxWidth:220 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:6 }}>
                      <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, color:"#888", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", maxWidth:160 }}>
                        /product/{p.slug}
                      </span>
                      <button onClick={() => copyUrl(p.slug)} style={{ background:"none", border:"none", cursor:"pointer", color: copied===p.slug ? C.accent : "#BBB", fontSize:12, flexShrink:0, transition:"color .2s" }}
                        title="URL 복사">
                        {copied === p.slug ? "✓" : "⧉"}
                      </button>
                    </div>
                  </td>
                  <td style={{ padding:"10px 14px" }}>
                    <div style={{ display:"flex", gap:8 }}>
                      <button className="adm-btn" onClick={() => startEdit(p)} style={{ background:C.accent, color:"#fff", fontSize:10, padding:"6px 14px" }}>수정</button>
                      <button className="adm-btn" onClick={() => deleteProduct(p.id)} style={{ background:"transparent", color:"#C0392B", border:"1px solid #F0D0CE", fontSize:10, padding:"6px 14px" }}>삭제</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     쿠폰 관리 — 목록
  ══════════════ */
  if (view === "coupons") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
            <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>쿠폰 관리</h2>
          </div>
          <button className="adm-btn" onClick={startAddCoupon} style={{ background:C.ink, color:"#fff" }}>+ 쿠폰 추가</button>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:28, textTransform:"uppercase" }}>
          신규가입 쿠폰으로 지정하려면 편집 화면에서 "신규가입 자동지급"을 켜세요
        </p>

        {couponsLoading ? (
          <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>불러오는 중...</p>
        ) : coupons.length === 0 ? (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"60px 0", textAlign:"center" }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>등록된 쿠폰이 없습니다.</p>
          </div>
        ) : (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, overflow:"hidden" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ borderBottom:"1px solid #F0F0EE", background:"#FAFAF8" }}>
                  {["이름","혜택","최소주문","기간","상태","",""].map(h => (
                    <th key={h} style={{ padding:"12px 14px", textAlign:"left", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, textTransform:"uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {coupons.map(c => (
                  <tr key={c.id} style={{ borderBottom:"1px solid #F5F5F3" }}>
                    <td style={{ padding:"10px 14px", fontSize:13 }}>
                      {c.title}
                      {c.is_welcome && <span style={{ marginLeft:8, fontSize:9, padding:"2px 7px", background:C.ink, color:"#fff", borderRadius:2 }}>신규가입</span>}
                      {c.code && <p style={{ fontSize:10, color:C.muted, marginTop:2 }}>코드: {c.code}</p>}
                    </td>
                    <td style={{ padding:"10px 14px", fontSize:12 }}>
                      {c.type === "percent" ? `${c.value}%${c.max_discount ? ` (최대 ₩${c.max_discount.toLocaleString()})` : ""}` : `₩${c.value.toLocaleString()}`}
                    </td>
                    <td style={{ padding:"10px 14px", fontSize:12, color:C.muted }}>₩{(c.min_order_amount||0).toLocaleString()}</td>
                    <td style={{ padding:"10px 14px", fontSize:11, color:C.muted }}>
                      {c.starts_at ? c.starts_at.slice(0,10) : "—"} ~ {c.expires_at ? c.expires_at.slice(0,10) : "무기한"}
                    </td>
                    <td style={{ padding:"10px 14px" }}>
                      <span style={{ fontSize:10, padding:"3px 8px", borderRadius:2, background: c.active ? "#E8F5EC" : "#F0F0EE", color: c.active ? "#3D8B5C" : C.muted }}>
                        {c.active ? "활성" : "비활성"}
                      </span>
                    </td>
                    <td style={{ padding:"10px 14px" }}>
                      <button className="adm-btn" onClick={() => openIssuePanel(c.id)} style={{ background:"#E8F0FB", color:C.accent, fontSize:10, padding:"6px 12px" }}>대상 지정 발급</button>
                    </td>
                    <td style={{ padding:"10px 14px" }}>
                      <div style={{ display:"flex", gap:8 }}>
                        <button className="adm-btn" onClick={() => startEditCoupon(c)} style={{ background:C.accent, color:"#fff", fontSize:10, padding:"6px 14px" }}>수정</button>
                        <button className="adm-btn" onClick={() => doDeleteCoupon(c.id)} style={{ background:"transparent", color:"#C0392B", border:"1px solid #F0D0CE", fontSize:10, padding:"6px 14px" }}>삭제</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* 대상 지정 발급 패널 */}
      {issuePanelFor && (
        <div style={{ position:"fixed", inset:0, background:"rgba(26,26,26,.5)", zIndex:5000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}
          onClick={() => setIssuePanelFor(null)}>
          <div style={{ background:"#fff", borderRadius:8, padding:28, width:"100%", maxWidth:440, maxHeight:"80vh", overflowY:"auto" }} onClick={e => e.stopPropagation()}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:600, fontSize:16, marginBottom:16 }}>쿠폰 대상 지정 발급</p>
            <input className="adm-input" placeholder="아이디 / 이름 / 이메일 검색" value={userQuery}
              onChange={e => doSearchUsers(e.target.value)} style={{ marginBottom:12 }} />
            <div style={{ maxHeight:220, overflowY:"auto", border:"1px solid #EEE", borderRadius:4, marginBottom:16 }}>
              {userResults.length === 0 ? (
                <p style={{ padding:16, fontSize:12, color:C.muted, textAlign:"center" }}>검색 결과가 없습니다.</p>
              ) : userResults.map(u => (
                <label key={u.id} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderBottom:"1px solid #F5F5F3", cursor:"pointer" }}>
                  <input type="checkbox" checked={selectedUsers.includes(u.id)} onChange={() => toggleSelectedUser(u.id)} />
                  <div>
                    <p style={{ fontSize:12 }}>{u.name} ({u.username})</p>
                    <p style={{ fontSize:10, color:C.muted }}>{u.email}</p>
                  </div>
                </label>
              ))}
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button className="adm-btn" onClick={() => setIssuePanelFor(null)} style={{ background:"#F0F0EE", color:C.ink }}>취소</button>
              <button className="adm-btn" onClick={doIssueCoupon} disabled={issuing || !selectedUsers.length}
                style={{ background:C.ink, color:"#fff", flex:1, opacity: (issuing || !selectedUsers.length) ? .6 : 1 }}>
                {issuing ? "발급 중..." : `선택한 ${selectedUsers.length}명에게 발급`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  /* ══════════════
     쿠폰 관리 — 생성/수정
  ══════════════ */
  if (view === "coupon-edit" && couponForm) return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:600, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:28 }}>
          <button onClick={() => setView("coupons")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>{couponForm.id ? "쿠폰 수정" : "쿠폰 추가"}</h2>
        </div>

        <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, display:"flex", flexDirection:"column", gap:16 }}>
          <AdmInput label="쿠폰 이름 *" value={couponForm.title}
            onChange={e => setCouponForm(p => ({ ...p, title: e.target.value }))} placeholder="예: 신규가입 10% 할인" />
          <AdmInput label="쿠폰 코드 (선택)" value={couponForm.code}
            onChange={e => setCouponForm(p => ({ ...p, code: e.target.value }))} placeholder="자동발급이면 비워두세요" />

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <div>
              <label className="adm-label">할인 유형</label>
              <select className="adm-input" value={couponForm.type}
                onChange={e => setCouponForm(p => ({ ...p, type: e.target.value }))}>
                <option value="percent">정률(%)</option>
                <option value="fixed">정액(₩)</option>
              </select>
            </div>
            <AdmInput label={couponForm.type === "percent" ? "할인율 (%)" : "할인 금액 (₩)"} type="number"
              value={couponForm.value} onChange={e => setCouponForm(p => ({ ...p, value: e.target.value }))} />
          </div>

          {couponForm.type === "percent" && (
            <AdmInput label="최대 할인 금액 (₩, 선택)" type="number" value={couponForm.maxDiscount}
              onChange={e => setCouponForm(p => ({ ...p, maxDiscount: e.target.value }))} placeholder="비워두면 제한 없음" />
          )}

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <AdmInput label="최소 주문금액 (₩)" type="number" value={couponForm.minOrderAmount}
              onChange={e => setCouponForm(p => ({ ...p, minOrderAmount: e.target.value }))} />
            <AdmInput label="1인당 사용 가능 횟수" type="number" value={couponForm.usageLimitPerUser}
              onChange={e => setCouponForm(p => ({ ...p, usageLimitPerUser: e.target.value }))} />
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
            <AdmInput label="시작일 (선택)" type="date" value={couponForm.startsAt}
              onChange={e => setCouponForm(p => ({ ...p, startsAt: e.target.value }))} />
            <AdmInput label="종료일 (선택)" type="date" value={couponForm.expiresAt}
              onChange={e => setCouponForm(p => ({ ...p, expiresAt: e.target.value }))} />
          </div>

          <label style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer", marginTop:4 }}>
            <input type="checkbox" checked={couponForm.isWelcome}
              onChange={e => setCouponForm(p => ({ ...p, isWelcome: e.target.checked }))} />
            <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12 }}>신규가입 자동지급 쿠폰으로 지정</span>
          </label>
          {couponForm.isWelcome && (
            <>
              <AdmInput label="가입 후 사용 가능 기간 (일, 비워두면 종료일 기준)"
                type="number" value={couponForm.welcomeExpiresDays}
                onChange={e => setCouponForm(p => ({ ...p, welcomeExpiresDays: e.target.value }))}
                placeholder="예: 7 (가입일로부터 7일)" />
              <p style={{ fontSize:11, color:"#C97A3D", marginTop:-8 }}>⚠ 활성 상태인 신규가입 쿠폰이 이미 있다면, 가장 최근에 만든 쿠폰이 자동 지급됩니다.</p>
            </>
          )}

          <label style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}>
            <input type="checkbox" checked={couponForm.active}
              onChange={e => setCouponForm(p => ({ ...p, active: e.target.checked }))} />
            <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12 }}>활성화</span>
          </label>
        </div>

        <div style={{ display:"flex", gap:10, marginTop:20 }}>
          <button className="adm-btn" onClick={() => setView("coupons")} style={{ background:"#F0F0EE", color:C.ink }}>취소</button>
          <button className="adm-btn" onClick={doSaveCoupon} disabled={couponSaving || !couponForm.title}
            style={{ background:C.ink, color:"#fff", flex:1, opacity: couponSaving ? .6 : 1 }}>
            {couponSaving ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     브랜드 이미지
  ══════════════ */
  if (view === "brand") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:800, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>브랜드 이미지</h2>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:28, textTransform:"uppercase" }}>
          메인페이지 브랜드 섹션과 About 페이지 이미지를 관리합니다
        </p>

        {brandForm && (
          <>
            {/* ── 메인페이지 브랜드 이미지 ── */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:16 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, marginBottom:16, textTransform:"uppercase" }}>메인페이지 — 브랜드 이미지</p>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, marginBottom:14, lineHeight:1.8 }}>
                메인 페이지 하단 &ldquo;ABOUT UNDERLOOKED&rdquo; 섹션 우측에 표시됩니다
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"200px 1fr", gap:20, alignItems:"start" }}>
                <label style={{ cursor:"pointer", display:"block" }}>
                  <div style={{ aspectRatio:"3/2", border:"2px dashed #DDD", borderRadius:4, overflow:"hidden", background:"#F5F5F3", position:"relative", transition:"border-color .18s" }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                    onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                    {brandForm.brandStrip
                      ? <>
                          <img src={brandForm.brandStrip} style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }} alt="" />
                          <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", opacity:0, transition:"opacity .2s" }}
                            onMouseEnter={e => e.currentTarget.style.opacity="1"}
                            onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                            <span style={{ color:"#fff", fontSize:11, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                          </div>
                        </>
                      : <div style={{ width:"100%", height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6 }}>
                          <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18 }}>+</div>
                          <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:"#CCC" }}>이미지 추가</span>
                        </div>
                    }
                  </div>
                  <input type="file" accept="image/*" style={{ display:"none" }}
                    onChange={e => handleBrandSingleImg("brandStrip", e.target.files[0])} />
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, marginTop:6, textAlign:"center" }}>클릭하여 이미지 변경</p>
                </label>
                <div style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, lineHeight:2 }}>
                  <p style={{ fontWeight:500, marginBottom:8, color:C.ink }}>권장 비율: 3:2 (가로형)</p>
                  <p>JPG · PNG · WEBP 지원</p>
                  <p>브랜드 룩북 이미지를 사용하세요</p>
                </div>
              </div>
            </div>

            {/* ── ABOUT 히어로 이미지 ── */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:16 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, marginBottom:16, textTransform:"uppercase" }}>About 페이지 — 히어로 이미지</p>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, marginBottom:14, lineHeight:1.8 }}>
                About 페이지 최상단 우측 전체 높이 이미지입니다
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"200px 1fr", gap:20, alignItems:"start" }}>
                <label style={{ cursor:"pointer", display:"block" }}>
                  <div style={{ aspectRatio:"4/5", border:"2px dashed #DDD", borderRadius:4, overflow:"hidden", background:"#F5F5F3", position:"relative", transition:"border-color .18s" }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                    onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                    {brandForm.aboutHero
                      ? <>
                          <img src={brandForm.aboutHero} style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }} alt="" />
                          <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", opacity:0, transition:"opacity .2s" }}
                            onMouseEnter={e => e.currentTarget.style.opacity="1"}
                            onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                            <span style={{ color:"#fff", fontSize:11, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                          </div>
                        </>
                      : <div style={{ width:"100%", height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6 }}>
                          <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18 }}>+</div>
                          <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:"#CCC" }}>이미지 추가</span>
                        </div>
                    }
                  </div>
                  <input type="file" accept="image/*" style={{ display:"none" }}
                    onChange={e => handleBrandSingleImg("aboutHero", e.target.files[0])} />
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, marginTop:6, textAlign:"center" }}>클릭하여 이미지 변경</p>
                </label>
                <div style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, lineHeight:2 }}>
                  <p style={{ fontWeight:500, marginBottom:8, color:C.ink }}>권장 비율: 세로형 (4:5)</p>
                  <p>JPG · PNG · WEBP 지원</p>
                  <p>어두운 배경에 어울리는 이미지를 사용하세요</p>
                </div>
              </div>
            </div>

            {/* ── ABOUT 컬렉션 이미지 ── */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:16 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, marginBottom:8, textTransform:"uppercase" }}>About 페이지 — 컬렉션 이미지</p>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, marginBottom:20, lineHeight:1.8 }}>
                About 페이지 하단 컬렉션 3개 컬럼의 이미지와 문구를 편집합니다
              </p>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:16 }}>
                {(brandForm.collections || []).map((item, idx) => (
                  <div key={idx}>
                    <input
                      className="adm-input"
                      value={item?.label || ""}
                      onChange={e => updateCollectionLabel(idx, e.target.value)}
                      placeholder="예: TRAINING"
                      style={{ marginBottom:8, textAlign:"center", fontSize:11, letterSpacing:2, textTransform:"uppercase" }}
                    />
                    <label style={{ cursor:"pointer", display:"block" }}>
                      <div style={{ aspectRatio:"3/4", border:"2px dashed #DDD", borderRadius:4, overflow:"hidden", background:"#F5F5F3", position:"relative", transition:"border-color .18s" }}
                        onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                        onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                        {item?.img
                          ? <>
                              <img src={item.img} style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }} alt="" />
                              <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", opacity:0, transition:"opacity .2s" }}
                                onMouseEnter={e => e.currentTarget.style.opacity="1"}
                                onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                                <span style={{ color:"#fff", fontSize:11, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                              </div>
                            </>
                          : <div style={{ width:"100%", height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6 }}>
                              <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18 }}>+</div>
                              <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:8, letterSpacing:2, color:"#CCC", textAlign:"center" }}>추가</span>
                            </div>
                        }
                      </div>
                      <input type="file" accept="image/*" style={{ display:"none" }}
                        onChange={e => handleBrandCollectionImg(idx, e.target.files[0])} />
                    </label>
                  </div>
                ))}
              </div>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, marginTop:12, lineHeight:1.8 }}>
                권장 비율: 3:4 (세로형) · JPG · PNG · WEBP 지원
              </p>
            </div>
          </>
        )}

        <div style={{ display:"flex", gap:12, marginTop:8 }}>
          <button className="adm-btn" onClick={() => setView("list")}
            style={{ background:"#F0F0EE", color:C.ink }}>
            취소
          </button>
          <button className="adm-btn" onClick={doSaveBrand} disabled={brandSaving}
            style={{ background:C.ink, color:"#fff", flex:1, opacity: brandSaving ? 0.6 : 1 }}>
            {brandSaving ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     히어로 슬라이드
  ══════════════ */
  if (view === "siteSettings") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:700, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>사이트 설정</h2>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:32, textTransform:"uppercase" }}>
          메인 배너 텍스트와 상단 이벤트 배너를 관리합니다
        </p>

        {siteSettingsForm && <>
          {/* 히어로 하단 배너 */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:20 }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, marginBottom:20, textTransform:"uppercase" }}>히어로 하단 배너 텍스트</p>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div>
                <label className="adm-label">왼쪽 텍스트</label>
                <input className="adm-input" value={siteSettingsForm.heroBannerLeft || ''} onChange={e => setSS('heroBannerLeft', e.target.value)} placeholder="26 S/S — NOW AVAILABLE" />
              </div>
              <div>
                <label className="adm-label">가운데 텍스트 (강조)</label>
                <input className="adm-input" value={siteSettingsForm.heroBannerCenter || ''} onChange={e => setSS('heroBannerCenter', e.target.value)} placeholder="FREE SHIPPING OVER ₩100,000" />
              </div>
              <div>
                <label className="adm-label">오른쪽 텍스트</label>
                <input className="adm-input" value={siteSettingsForm.heroBannerRight || ''} onChange={e => setSS('heroBannerRight', e.target.value)} placeholder="UNDERLOOKED ✦ SEOUL" />
              </div>
            </div>
          </div>

          {/* 이벤트 배너 */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:28 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, textTransform:"uppercase" }}>상단 이벤트 배너</p>
              <label style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}>
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>노출</span>
                <div onClick={() => setEB('enabled', !siteSettingsForm.eventBanner?.enabled)}
                  style={{ width:40, height:22, borderRadius:11, background:siteSettingsForm.eventBanner?.enabled ? C.accent : '#DDD', position:"relative", cursor:"pointer", transition:"background .2s" }}>
                  <div style={{ position:"absolute", top:3, left:siteSettingsForm.eventBanner?.enabled ? 21 : 3, width:16, height:16, borderRadius:"50%", background:"#fff", transition:"left .2s" }} />
                </div>
              </label>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <div>
                <label className="adm-label">배너 문구</label>
                <input className="adm-input" value={siteSettingsForm.eventBanner?.text || ''} onChange={e => setEB('text', e.target.value)} placeholder="회원가입 시 ₩3,000 쿠폰 지급" />
              </div>
              <div>
                <label className="adm-label">링크 URL (선택)</label>
                <input className="adm-input" value={siteSettingsForm.eventBanner?.link || ''} onChange={e => setEB('link', e.target.value)} placeholder="https://..." />
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <div>
                  <label className="adm-label">배경색</label>
                  <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                    <input type="color" value={siteSettingsForm.eventBanner?.bgColor || '#1A1A1A'} onChange={e => setEB('bgColor', e.target.value)}
                      style={{ width:40, height:36, border:"1px solid #DDD", borderRadius:4, cursor:"pointer", padding:2 }} />
                    <input className="adm-input" value={siteSettingsForm.eventBanner?.bgColor || '#1A1A1A'} onChange={e => setEB('bgColor', e.target.value)} style={{ maxWidth:120 }} />
                  </div>
                </div>
                <div>
                  <label className="adm-label">텍스트 색</label>
                  <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                    <input type="color" value={siteSettingsForm.eventBanner?.textColor || '#F2F1ED'} onChange={e => setEB('textColor', e.target.value)}
                      style={{ width:40, height:36, border:"1px solid #DDD", borderRadius:4, cursor:"pointer", padding:2 }} />
                    <input className="adm-input" value={siteSettingsForm.eventBanner?.textColor || '#F2F1ED'} onChange={e => setEB('textColor', e.target.value)} style={{ maxWidth:120 }} />
                  </div>
                </div>
              </div>
              {/* 미리보기 */}
              {siteSettingsForm.eventBanner?.text && (
                <div style={{ marginTop:8 }}>
                  <label className="adm-label">미리보기</label>
                  <div style={{ height:36, background:siteSettingsForm.eventBanner?.bgColor || '#1A1A1A', display:"flex", alignItems:"center", justifyContent:"center", borderRadius:4 }}>
                    <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, letterSpacing:2, color:siteSettingsForm.eventBanner?.textColor || '#F2F1ED' }}>
                      {siteSettingsForm.eventBanner.text}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* 쿠폰 팝업 배너 */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:28 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted, textTransform:"uppercase" }}>쿠폰 팝업 배너</p>
              <label style={{ display:"flex", alignItems:"center", gap:10, cursor:"pointer" }}>
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>노출</span>
                <div onClick={() => setCB('enabled', !siteSettingsForm.couponBanner?.enabled)}
                  style={{ width:40, height:22, borderRadius:11, background:siteSettingsForm.couponBanner?.enabled ? C.accent : '#DDD', position:"relative", cursor:"pointer", transition:"background .2s" }}>
                  <div style={{ position:"absolute", top:3, left:siteSettingsForm.couponBanner?.enabled ? 21 : 3, width:16, height:16, borderRadius:"50%", background:"#fff", transition:"left .2s" }} />
                </div>
              </label>
            </div>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              {/* 배너 이미지 */}
              <div>
                <label className="adm-label">배너 이미지 (선택)</label>
                {siteSettingsForm.couponBanner?.image ? (
                  <div style={{ position:"relative", marginBottom:8 }}>
                    <img src={siteSettingsForm.couponBanner.image} alt="" style={{ width:"100%", maxHeight:160, objectFit:"cover", display:"block", borderRadius:4, border:"1px solid #DDD" }} />
                    <button onClick={() => setCB('image', null)} style={{ position:"absolute", top:6, right:6, background:"rgba(0,0,0,0.55)", border:"none", color:"#fff", fontSize:13, cursor:"pointer", borderRadius:"50%", width:26, height:26 }}>×</button>
                  </div>
                ) : (
                  <label style={{ display:"block", border:"2px dashed #DDD", borderRadius:4, padding:"20px 0", textAlign:"center", cursor:"pointer", color:C.muted, fontSize:12 }}>
                    클릭하여 이미지 업로드
                    <input type="file" accept="image/*" style={{ display:"none" }} onChange={e => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      const reader = new FileReader();
                      reader.onload = ev => setCB('image', ev.target.result);
                      reader.readAsDataURL(file);
                    }} />
                  </label>
                )}
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <div>
                  <label className="adm-label">타이틀</label>
                  <input className="adm-input" value={siteSettingsForm.couponBanner?.title || ''} onChange={e => setCB('title', e.target.value)} placeholder="신규 회원 혜택" />
                </div>
                <div>
                  <label className="adm-label">할인 금액 표시</label>
                  <input className="adm-input" value={siteSettingsForm.couponBanner?.discountText || ''} onChange={e => setCB('discountText', e.target.value)} placeholder="₩3,000 할인" />
                </div>
              </div>
              <div>
                <label className="adm-label">설명 문구</label>
                <input className="adm-input" value={siteSettingsForm.couponBanner?.description || ''} onChange={e => setCB('description', e.target.value)} placeholder="지금 가입하고 첫 주문 시 사용하세요" />
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14 }}>
                <div>
                  <label className="adm-label">버튼 텍스트</label>
                  <input className="adm-input" value={siteSettingsForm.couponBanner?.ctaText || ''} onChange={e => setCB('ctaText', e.target.value)} placeholder="쿠폰 받기" />
                </div>
                <div>
                  <label className="adm-label">발급 쿠폰 코드</label>
                  <input className="adm-input" value={siteSettingsForm.couponBanner?.code || ''} onChange={e => setCB('code', e.target.value)} placeholder="WELCOME3000" style={{ letterSpacing:2 }} />
                </div>
                <div>
                  <label className="adm-label">표시 지연 (초)</label>
                  <input className="adm-input" type="number" min={0} max={30} value={siteSettingsForm.couponBanner?.delaySeconds ?? 3} onChange={e => setCB('delaySeconds', Number(e.target.value))} />
                </div>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14 }}>
                <div>
                  <label className="adm-label">배경색</label>
                  <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                    <input type="color" value={siteSettingsForm.couponBanner?.bgColor || '#1A1A1A'} onChange={e => setCB('bgColor', e.target.value)}
                      style={{ width:36, height:34, border:"1px solid #DDD", borderRadius:4, cursor:"pointer", padding:2 }} />
                    <input className="adm-input" value={siteSettingsForm.couponBanner?.bgColor || '#1A1A1A'} onChange={e => setCB('bgColor', e.target.value)} />
                  </div>
                </div>
                <div>
                  <label className="adm-label">텍스트 색</label>
                  <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                    <input type="color" value={siteSettingsForm.couponBanner?.textColor || '#F2F1ED'} onChange={e => setCB('textColor', e.target.value)}
                      style={{ width:36, height:34, border:"1px solid #DDD", borderRadius:4, cursor:"pointer", padding:2 }} />
                    <input className="adm-input" value={siteSettingsForm.couponBanner?.textColor || '#F2F1ED'} onChange={e => setCB('textColor', e.target.value)} />
                  </div>
                </div>
                <div>
                  <label className="adm-label">강조 색 (버튼)</label>
                  <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                    <input type="color" value={siteSettingsForm.couponBanner?.accentColor || '#C97A3D'} onChange={e => setCB('accentColor', e.target.value)}
                      style={{ width:36, height:34, border:"1px solid #DDD", borderRadius:4, cursor:"pointer", padding:2 }} />
                    <input className="adm-input" value={siteSettingsForm.couponBanner?.accentColor || '#C97A3D'} onChange={e => setCB('accentColor', e.target.value)} />
                  </div>
                </div>
              </div>
              {/* 미리보기 */}
              <div style={{ marginTop:4 }}>
                <label className="adm-label">미리보기</label>
                <div style={{ background:siteSettingsForm.couponBanner?.bgColor || '#1A1A1A', maxWidth:280, overflow:"hidden" }}>
                  {siteSettingsForm.couponBanner?.image && (
                    <img src={siteSettingsForm.couponBanner.image} alt="" style={{ width:"100%", maxHeight:100, objectFit:"cover", display:"block" }} />
                  )}
                  <div style={{ padding:"14px 16px 12px" }}>
                    <p style={{ fontFamily:"'DM Serif Display',serif", fontSize:22, color:siteSettingsForm.couponBanner?.accentColor || '#C97A3D', marginBottom:4 }}>
                      {siteSettingsForm.couponBanner?.discountText || '₩3,000 할인'}
                    </p>
                    <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, fontWeight:600, color:siteSettingsForm.couponBanner?.textColor || '#F2F1ED', marginBottom:2 }}>
                      {siteSettingsForm.couponBanner?.title || '신규 회원 혜택'}
                    </p>
                    <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color:siteSettingsForm.couponBanner?.textColor || '#F2F1ED', opacity:.6, marginBottom:10 }}>
                      {siteSettingsForm.couponBanner?.description}
                    </p>
                    <div style={{ padding:"9px 0", background:siteSettingsForm.couponBanner?.accentColor || '#C97A3D', color:"#fff", textAlign:"center", fontFamily:"'Pretendard',sans-serif", fontSize:11, fontWeight:700, letterSpacing:1 }}>
                      {siteSettingsForm.couponBanner?.ctaText || '쿠폰 받기'}
                    </div>
                  </div>
                  <div style={{ display:"flex", borderTop:"1px solid rgba(255,255,255,0.1)" }}>
                    <div style={{ flex:1, padding:"9px 0", textAlign:"center", color:siteSettingsForm.couponBanner?.textColor || '#F2F1ED', fontSize:10, opacity:.45, fontFamily:"'Pretendard',sans-serif" }}>다시 보지 않기</div>
                    <div style={{ flex:1, padding:"9px 0", textAlign:"center", color:siteSettingsForm.couponBanner?.textColor || '#F2F1ED', fontSize:10, opacity:.45, borderLeft:"1px solid rgba(255,255,255,0.1)", fontFamily:"'Pretendard',sans-serif" }}>닫기</div>
                  </div>
                </div>
              </div>
              <p style={{ fontSize:11, color:C.muted, lineHeight:1.6 }}>
                * 발급 쿠폰 코드는 관리자 &gt; 쿠폰 관리에서 먼저 생성되어 있어야 합니다.<br />
                * 로그인한 사용자만 쿠폰 발급이 가능하며, 미로그인 시 홈으로 이동합니다.
              </p>
            </div>
          </div>

          {/* ── 소셜 링크 ── */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:20 }}>
            <h3 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:14, marginBottom:4 }}>소셜 미디어 링크</h3>
            <p style={{ fontSize:11, color:C.muted, marginBottom:20 }}>입력한 링크는 푸터에 표시됩니다. 비워두면 해당 항목은 숨겨집니다.</p>
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              {[
                { key:"instagram", label:"Instagram", placeholder:"https://instagram.com/underlooked" },
                { key:"tiktok",    label:"TikTok",    placeholder:"https://tiktok.com/@underlooked" },
                { key:"kakao",     label:"KakaoTalk", placeholder:"https://open.kakao.com/..." },
              ].map(({ key, label, placeholder }) => (
                <div key={key}>
                  <label className="adm-label">{label}</label>
                  <input className="adm-input"
                    value={siteSettingsForm.socialLinks?.[key] || ''}
                    onChange={e => setSS('socialLinks', { ...(siteSettingsForm.socialLinks || {}), [key]: e.target.value })}
                    placeholder={placeholder} />
                </div>
              ))}
            </div>
          </div>

          {/* ── 푸터 링크 편집 ── */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:20 }}>
            <h3 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:14, marginBottom:4 }}>푸터 메뉴</h3>
            <p style={{ fontSize:11, color:C.muted, marginBottom:20 }}>링크 이름을 수정하거나 숨김 처리할 수 있습니다.</p>
            {[
              { key: "shop", title: "SHOP" },
              { key: "info", title: "INFO" },
              { key: "help", title: "HELP" },
            ].map(({ key, title }) => (
              <div key={key} style={{ marginBottom:20 }}>
                <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:"#888", marginBottom:10 }}>{title}</p>
                {(siteSettingsForm.footerLinks?.[key] || []).map((item, idx) => (
                  <div key={idx} style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                    <input
                      className="adm-input"
                      value={item.label}
                      onChange={e => setFL(key, idx, 'label', e.target.value)}
                      style={{ flex:1 }}
                    />
                    <label style={{ display:"flex", alignItems:"center", gap:6, cursor:"pointer", userSelect:"none", flexShrink:0 }}>
                      <div onClick={() => setFL(key, idx, 'visible', !item.visible)}
                        style={{ width:36, height:20, borderRadius:10, background:item.visible ? C.accent : '#DDD', position:"relative", cursor:"pointer", transition:"background .2s", flexShrink:0 }}>
                        <div style={{ position:"absolute", top:2, left:item.visible ? 18 : 2, width:16, height:16, borderRadius:"50%", background:"#fff", transition:"left .2s" }} />
                      </div>
                      <span style={{ fontSize:11, color:C.muted }}>{item.visible ? "표시" : "숨김"}</span>
                    </label>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* ── 결제수단 관리 ── */}
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:20 }}>
            <h3 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:14, marginBottom:4 }}>결제수단 노출 관리</h3>
            <p style={{ fontSize:11, color:C.muted, marginBottom:20 }}>심사 완료 후 토글을 켜면 즉시 노출됩니다. 재배포 불필요.</p>
            {[
              { key:"bank",     label:"무통장입금",        desc:"항상 사용 권장" },
              { key:"card",     label:"카드결제 (토스페이먼츠)", desc:"토스페이먼츠 심사 완료 후 활성화" },
              { key:"naverPay", label:"네이버페이 간편결제",  desc:"네이버페이 가맹점 심사 완료 후 활성화" },
              { key:"kakaoPay", label:"카카오페이 간편결제",  desc:"카카오페이 가맹점 심사 완료 후 활성화" },
            ].map(({ key, label, desc }) => (
              <div key={key} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"14px 0", borderBottom:"1px solid #F0F0EE" }}>
                <div>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, fontWeight:500, color:C.ink, marginBottom:2 }}>{label}</p>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:C.muted }}>{desc}</p>
                </div>
                <div onClick={() => key !== 'bank' && setPM(key, !(siteSettingsForm.paymentMethods?.[key]))}
                  style={{ width:40, height:22, borderRadius:11, background:(siteSettingsForm.paymentMethods?.[key] ?? (key==='bank')) ? C.accent : '#DDD',
                    position:"relative", cursor: key === 'bank' ? 'default' : 'pointer', transition:"background .2s", flexShrink:0 }}>
                  <div style={{ position:"absolute", top:3, left:(siteSettingsForm.paymentMethods?.[key] ?? (key==='bank')) ? 21 : 3, width:16, height:16, borderRadius:"50%", background:"#fff", transition:"left .2s" }} />
                </div>
              </div>
            ))}
          </div>

          <button className="adm-btn" onClick={doSaveSiteSettings} disabled={siteSettingsSaving}
            style={{ background:C.ink, color:"#fff", width:"100%", padding:"14px 0", fontSize:13, opacity:siteSettingsSaving ? .6 : 1 }}>
            {siteSettingsSaving ? "저장 중..." : "저장"}
          </button>
        </>}
      </div>
    </div>
  );

  if (view === "slides") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:800, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>히어로 슬라이드</h2>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:28, textTransform:"uppercase" }}>
          메인 페이지 상단 풀스크린 이미지와 텍스트를 편집합니다
        </p>

        {slidesForm && slidesForm.map((slide, si) => (
          <div key={si} style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:16 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
              <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:3, color:C.muted }}>SLIDE {si + 1}</span>
              <button className="adm-btn" onClick={() => removeSlide(si)}
                style={{ background:"transparent", color:"#C0392B", border:"1px solid #F0D0CE", fontSize:11, padding:"5px 12px" }}>
                삭제
              </button>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"200px 1fr", gap:20, alignItems:"start" }}>
              {/* 이미지 업로드 */}
              <label style={{ cursor:"pointer", display:"block" }}>
                <div style={{
                  aspectRatio:"16/9", border:"2px dashed #DDD", borderRadius:4,
                  overflow:"hidden", background:"#F5F5F3", position:"relative",
                  transition:"border-color .18s",
                }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = C.accent}
                  onMouseLeave={e => e.currentTarget.style.borderColor = "#DDD"}>
                  {slide.img
                    ? <>
                        <img src={slide.img} style={{ width:"100%", height:"100%", objectFit:"cover", position:"absolute", inset:0 }} alt="" />
                        <div style={{ position:"absolute", inset:0, background:"rgba(0,0,0,.4)", display:"flex", alignItems:"center", justifyContent:"center", opacity:0, transition:"opacity .2s" }}
                          onMouseEnter={e => e.currentTarget.style.opacity="1"}
                          onMouseLeave={e => e.currentTarget.style.opacity="0"}>
                          <span style={{ color:"#fff", fontSize:11, fontFamily:"'Presentation5',sans-serif", fontWeight:500, letterSpacing:2 }}>변경</span>
                        </div>
                      </>
                    : <div style={{ width:"100%", height:"100%", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:6 }}>
                        <div style={{ width:28, height:28, borderRadius:"50%", border:"1px solid #DDD", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:18 }}>+</div>
                        <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:"#CCC" }}>이미지 추가</span>
                      </div>
                  }
                </div>
                <input type="file" accept="image/*" style={{ display:"none" }}
                  onChange={e => handleSlideImg(si, e.target.files[0])} />
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, marginTop:6, textAlign:"center" }}>
                  클릭하여 이미지 변경
                </p>
              </label>

              {/* 텍스트 입력 */}
              <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                <div>
                  <label className="adm-label">제목 (Label)</label>
                  <input className="adm-input" value={slide.label}
                    onChange={e => updateSlide(si, "label", e.target.value)}
                    placeholder="예: 26 S/S — TRAINING" />
                </div>
                <div>
                  <label className="adm-label">부제목 (Sub)</label>
                  <input className="adm-input" value={slide.sub}
                    onChange={e => updateSlide(si, "sub", e.target.value)}
                    placeholder="예: 움직임을 위해 설계된 옷" />
                </div>
              </div>
            </div>
          </div>
        ))}

        <div style={{ display:"flex", gap:12, marginTop:8 }}>
          <button className="adm-btn" onClick={addSlide}
            style={{ background:"#F0F0EE", color:C.ink }}>
            + 슬라이드 추가
          </button>
          <button className="adm-btn" onClick={doSaveSlides} disabled={slidesSaving}
            style={{ background:C.ink, color:"#fff", flex:1, opacity: slidesSaving ? 0.6 : 1 }}>
            {slidesSaving ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     메뉴 설정
  ══════════════ */
  if (view === "nav") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:760, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:4 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>전체 메뉴 관리</h2>
        </div>

        {/* ── 섹션 1: 상단 내비게이션 항목 ── */}
        <div style={{ marginBottom:40 }}>
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, paddingBottom:10, borderBottom:`2px solid ${C.ink}` }}>
            <div>
              <h3 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:600, fontSize:13, marginBottom:3 }}>상단 메뉴 항목</h3>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, textTransform:"uppercase" }}>
                헤더 상단에 표시되는 메뉴 항목을 관리합니다
              </p>
            </div>
            <button className="adm-btn" onClick={addMainMenuItem}
              style={{ background:C.ink, color:"#fff", whiteSpace:"nowrap" }}>
              + 항목 추가
            </button>
          </div>

          {/* 컬럼 헤더 */}
          <div style={{ display:"grid", gridTemplateColumns:"32px 1fr 160px 64px 70px 32px", gap:"0 8px", alignItems:"center", padding:"0 12px 6px", marginBottom:4 }}>
            {["순서", "표시 이름", "메뉴 타입", "노출 여부", "", ""].map((h, i) => (
              <span key={i} style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:8, letterSpacing:2, color:C.muted, textTransform:"uppercase" }}>{h}</span>
            ))}
          </div>

          {mainMenuForm && mainMenuForm.map((item, idx) => (
            <div key={item.id || idx} style={{ display:"grid", gridTemplateColumns:"32px 1fr 160px 64px 70px 32px", gap:"0 8px", alignItems:"center", background:"#fff", border:"1px solid #E8E8E6", borderRadius:4, padding:"10px 12px", marginBottom:6 }}>
              {/* 순서 버튼 */}
              <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
                <button onClick={() => moveMainMenuItem(idx, -1)} disabled={idx === 0}
                  style={{ background:"none", border:"1px solid #E0E0DE", borderRadius:2, padding:"2px 5px", cursor:"pointer", fontSize:10, opacity: idx === 0 ? 0.3 : 1 }}>▲</button>
                <button onClick={() => moveMainMenuItem(idx, 1)} disabled={idx === mainMenuForm.length - 1}
                  style={{ background:"none", border:"1px solid #E0E0DE", borderRadius:2, padding:"2px 5px", cursor:"pointer", fontSize:10, opacity: idx === mainMenuForm.length - 1 ? 0.3 : 1 }}>▼</button>
              </div>

              {/* 표시 이름 */}
              <input className="adm-input" value={item.label}
                onChange={e => updateMainMenuItem(idx, "label", e.target.value)}
                style={{ margin:0 }} />

              {/* 메뉴 타입 */}
              <select className="adm-input" value={item.type}
                onChange={e => updateMainMenuItem(idx, "type", e.target.value)}
                style={{ margin:0 }}>
                {MENU_TYPE_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>

              {/* 노출 여부 토글 */}
              <div style={{ display:"flex", alignItems:"center", justifyContent:"center" }}>
                <button
                  onClick={() => updateMainMenuItem(idx, "visible", !item.visible)}
                  style={{
                    width:40, height:22, borderRadius:11, border:"none", cursor:"pointer",
                    background: item.visible !== false ? C.accent : "#D0D0CE",
                    position:"relative", transition:"background .2s",
                  }}>
                  <span style={{
                    position:"absolute", top:3, width:16, height:16, borderRadius:"50%",
                    background:"#fff", transition:"left .2s",
                    left: item.visible !== false ? 21 : 3,
                  }} />
                </button>
              </div>

              {/* 노출 상태 텍스트 */}
              <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color: item.visible !== false ? C.accent : C.muted, textAlign:"center" }}>
                {item.visible !== false ? "노출" : "숨김"}
              </span>

              {/* 삭제 */}
              <button onClick={() => removeMainMenuItem(idx)}
                style={{ background:"transparent", border:"1px solid #F0D0CE", color:"#C0392B", borderRadius:3, padding:"4px 6px", cursor:"pointer", fontSize:11 }}>✕</button>
            </div>
          ))}

          <div style={{ marginTop:12 }}>
            <button className="adm-btn" onClick={doSaveMainMenu} disabled={mainMenuSaving}
              style={{ background:C.ink, color:"#fff", width:"100%", opacity: mainMenuSaving ? 0.6 : 1 }}>
              {mainMenuSaving ? "저장 중..." : "상단 메뉴 저장"}
            </button>
          </div>
        </div>

        {/* ── 섹션 2: SHOP 드롭다운 카테고리 ── */}
        <div>
          <div style={{ marginBottom:16, paddingBottom:10, borderBottom:`2px solid ${C.ink}` }}>
            <h3 style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:600, fontSize:13, marginBottom:3 }}>SHOP 드롭다운 카테고리</h3>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, textTransform:"uppercase" }}>
              Shop 메뉴 클릭 시 표시되는 카테고리와 하위 항목
            </p>
          </div>

          {navForm && navForm.map((cat, ci) => (
            <div key={ci} style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, marginBottom:16 }}>
              <div style={{ display:"flex", gap:12, marginBottom:16, alignItems:"flex-end" }}>
                <div style={{ flex:1 }}>
                  <label className="adm-label">카테고리 제목</label>
                  <input className="adm-input" value={cat.title}
                    onChange={e => updateNavCat(ci, "title", e.target.value)} />
                </div>
                <div style={{ flex:1 }}>
                  <label className="adm-label">필터값 (Top / Bottom / Outwear / All)</label>
                  <input className="adm-input" value={cat.catFilter}
                    onChange={e => updateNavCat(ci, "catFilter", e.target.value)} />
                </div>
                <button className="adm-btn" onClick={() => removeNavCat(ci)}
                  style={{ background:"transparent", color:"#C0392B", border:"1px solid #F0D0CE", flexShrink:0 }}>
                  삭제
                </button>
              </div>

              <label className="adm-label" style={{ display:"block", marginBottom:4 }}>하위 메뉴 항목</label>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 10px 1fr 32px", gap:"4px 6px", alignItems:"center", marginBottom:4 }}>
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:8, letterSpacing:2, color:C.muted }}>표시 이름</span>
                <span />
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:8, letterSpacing:2, color:C.muted }}>소분류 값 (제품 소분류와 동일)</span>
                <span />
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                {cat.items.map((item, ii) => {
                  const label     = typeof item === "string" ? item : item.label;
                  const filterVal = typeof item === "string" ? item : item.filter;
                  return (
                    <div key={ii} style={{ display:"grid", gridTemplateColumns:"1fr 10px 1fr 32px", gap:"4px 6px", alignItems:"center" }}>
                      <input className="adm-input" value={label}
                        onChange={e => updateNavItem(ci, ii, "label", e.target.value)}
                        placeholder="예: T-Shirts" />
                      <span style={{ textAlign:"center", color:C.muted, fontSize:11 }}>→</span>
                      <input className="adm-input" value={filterVal}
                        onChange={e => updateNavItem(ci, ii, "filter", e.target.value)}
                        placeholder="예: T-Shirts" />
                      <button className="adm-btn" onClick={() => removeNavItem(ci, ii)}
                        style={{ background:"transparent", color:"#C0392B", border:"1px solid #F0D0CE", padding:"8px 0", flexShrink:0 }}>✕</button>
                    </div>
                  );
                })}
              </div>
              <button className="adm-btn" onClick={() => addNavItem(ci)}
                style={{ marginTop:10, background:"#F0F0EE", color:C.ink, width:"100%" }}>
                + 항목 추가
              </button>
            </div>
          ))}

          <div style={{ display:"flex", gap:12, marginTop:8 }}>
            <button className="adm-btn" onClick={addNavCat}
              style={{ background:"#F0F0EE", color:C.ink }}>
              + 카테고리 추가
            </button>
            <button className="adm-btn" onClick={doSaveNav} disabled={navSaving}
              style={{ background:C.ink, color:"#fff", flex:1, opacity: navSaving ? 0.6 : 1 }}>
              {navSaving ? "저장 중..." : "SHOP 카테고리 저장"}
            </button>
          </div>
        </div>

      </div>
    </div>
  );

  /* ══════════════
     주문 관리
  ══════════════ */
  const STATUS_OPTIONS = [
    { value:"pending",   label:"입금 대기", color:"#E8A838" },
    { value:"confirmed", label:"주문 확인", color:"#4A7AB5" },
    { value:"shipping",  label:"배송 중",   color:"#3D8B5C" },
    { value:"delivered", label:"배송 완료", color:"#888"    },
    { value:"cancelled", label:"취소됨",   color:"#C94040" },
  ];

  if (view === "orders") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
            <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>주문 관리</h2>
          </div>
          <button onClick={openOrders} style={{ background:"#F0F0EE", color:C.ink, fontFamily:"'Presentation5',sans-serif", fontSize:11, border:"none", padding:"8px 16px", cursor:"pointer", borderRadius:3 }}>새로고침</button>
        </div>

        {/* 검색 + 정렬 */}
        <div style={{ display:"flex", gap:10, marginBottom:12, alignItems:"center" }}>
          <input
            className="adm-input" style={{ flex:1, maxWidth:280 }}
            placeholder="주문번호 앞자리로 검색..."
            value={orderSearch} onChange={e => setOrderSearch(e.target.value)} />
          <button onClick={() => setOrderSortAsc(a => !a)}
            style={{ background:"#F0F0EE", border:"none", padding:"9px 14px", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontSize:11, borderRadius:3 }}>
            {orderSortAsc ? "오래된 순 ↑" : "최신순 ↓"}
          </button>
        </div>

        {/* 상태 필터 */}
        <div style={{ display:"flex", gap:6, marginBottom:20, flexWrap:"wrap" }}>
          {[{value:"all",label:"전체"}, ...STATUS_OPTIONS].map(s => (
            <button key={s.value} onClick={() => setOrderStatusFilter(s.value)}
              style={{ padding:"5px 12px", border:`1px solid ${orderStatusFilter===s.value ? C.ink : "#DDD"}`,
                background: orderStatusFilter===s.value ? C.ink : "transparent",
                color: orderStatusFilter===s.value ? "#fff" : "#666",
                fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1, cursor:"pointer", borderRadius:2 }}>
              {s.label}
            </button>
          ))}
        </div>

        {ordersLoading ? (
          <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>불러오는 중...</p>
        ) : (() => {
          const filtered = allOrders
            .filter(o => orderStatusFilter === "all" || o.status === orderStatusFilter)
            .filter(o => !orderSearch.trim() || (o.order_number || o.id).toLowerCase().includes(orderSearch.trim().toLowerCase()))
            .sort((a, b) => orderSortAsc
              ? new Date(a.created_at) - new Date(b.created_at)
              : new Date(b.created_at) - new Date(a.created_at));
          return filtered.length === 0 ? (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"60px 0", textAlign:"center" }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>해당 주문이 없습니다.</p>
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, marginBottom:4 }}>총 {filtered.length}건</p>
            {filtered.map(order => {
              const isOpen  = expandedOrder === order.id;
              const statusInfo = STATUS_OPTIONS.find(s => s.value === order.status) || STATUS_OPTIONS[0];
              const date    = new Date(order.created_at).toLocaleDateString("ko-KR", { year:"numeric", month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit" });
              const itemSummary = (order.items || []).map(i => `${i.productName} (${i.size}) x${i.quantity}`).join(", ");

              return (
                <div key={order.id} style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, overflow:"hidden" }}>
                  {/* 주문 요약 행 */}
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 2fr 140px 100px 32px", gap:16, padding:"14px 20px", alignItems:"center", cursor:"pointer" }}
                    onClick={() => setExpandedOrder(isOpen ? null : order.id)}>
                    <div>
                      <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:11, marginBottom:3 }}>
                        {order.order_number || order.id.slice(0,8).toUpperCase()}
                      </p>
                      <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted }}>{date}</p>
                    </div>
                    <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                      {itemSummary}
                    </p>
                    <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:13, textAlign:"right" }}>
                      ₩{order.total.toLocaleString()}
                    </p>
                    <span style={{ display:"inline-block", padding:"4px 10px", border:`1px solid ${statusInfo.color}`, color:statusInfo.color, fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1, borderRadius:2, textAlign:"center" }}>
                      {statusInfo.label}
                    </span>
                    <span style={{ color:C.muted, fontSize:12, textAlign:"center", transition:"transform .2s", display:"inline-block", transform: isOpen ? "rotate(180deg)" : "none" }}>▾</span>
                  </div>

                  {/* 주문 상세 */}
                  {isOpen && (
                    <div style={{ borderTop:"1px solid #F0F0EE", padding:"20px", background:"#FAFAF8", display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:24 }}>

                      {/* 주문 상품 */}
                      <div>
                        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, marginBottom:12, textTransform:"uppercase" }}>주문 상품</p>
                        {(order.items || []).map((item, i) => (
                          <div key={i} style={{ display:"flex", justifyContent:"space-between", marginBottom:8, paddingBottom:8, borderBottom:"1px solid #EBEBEB" }}>
                            <div>
                              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, marginBottom:2 }}>{item.productName}</p>
                              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted }}>
                                {item.size}{item.colorName ? ` · ${item.colorName}` : ""} · {item.quantity}개
                              </p>
                            </div>
                            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12 }}>₩{(item.price * item.quantity).toLocaleString()}</p>
                          </div>
                        ))}
                        <div style={{ display:"flex", justifyContent:"space-between", marginTop:8 }}>
                          <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted }}>합계</span>
                          <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:13 }}>₩{order.total.toLocaleString()}</span>
                        </div>
                      </div>

                      {/* 배송지 */}
                      <div>
                        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, marginBottom:12, textTransform:"uppercase" }}>배송지</p>
                        {[
                          ["수령인", order.shipping?.name],
                          ["연락처", order.shipping?.phone],
                          ["주소",   `(${order.shipping?.zip || ""}) ${order.shipping?.address1 || ""} ${order.shipping?.address2 || ""}`],
                          ["메모",   order.shipping?.note],
                        ].filter(([, v]) => v?.trim()).map(([label, val]) => (
                          <div key={label} style={{ display:"flex", gap:10, marginBottom:7 }}>
                            <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted, minWidth:44 }}>{label}</span>
                            <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11 }}>{val}</span>
                          </div>
                        ))}
                      </div>

                      {/* 상태 변경 */}
                      <div>
                        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, marginBottom:12, textTransform:"uppercase" }}>주문 상태 변경</p>
                        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                          {STATUS_OPTIONS.map(s => (
                            <button key={s.value}
                              onClick={() => updateOrderStatus(order.id, s.value)}
                              disabled={statusSaving === order.id}
                              style={{
                                padding:"9px 14px", border:`1px solid ${order.status === s.value ? s.color : "#E0E0DE"}`,
                                background: order.status === s.value ? s.color : "transparent",
                                color: order.status === s.value ? "#fff" : s.color,
                                fontFamily:"'Presentation5',sans-serif", fontSize:11, letterSpacing:1,
                                cursor:"pointer", borderRadius:3, transition:"all .15s", textAlign:"left",
                                opacity: statusSaving === order.id ? .6 : 1,
                              }}>
                              {order.status === s.value ? "✓ " : ""}{s.label}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
        })()}
      </div>
    </div>
  );

  /* ══════════════
     노출 순서 설정
  ══════════════ */
  if (view === "order") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:640, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>노출 순서 설정</h2>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:28 }}>
          드래그하여 순서를 변경한 뒤 저장 버튼을 눌러주세요
        </p>

        <div style={{ display:"flex", flexDirection:"column", gap:4, marginBottom:24 }}>
          {orderForm && orderForm.map((p, idx) => (
            <div key={p.id}
              draggable
              onDragStart={(e) => onDragStart(e, idx)}
              onDragOver={(e) => onDragOver(e, idx)}
              onDragEnd={onDragEnd}
              style={{
                background:"#fff",
                border: dragIdx === idx ? `2px solid ${C.accent}` : "1px solid #E8E8E6",
                borderRadius:6,
                padding:"10px 16px",
                display:"flex",
                alignItems:"center",
                gap:14,
                cursor:"grab",
                opacity: dragIdx === idx ? 0.45 : 1,
                transition:"border-color .15s, opacity .15s",
                userSelect:"none",
              }}>
              <span style={{ color:"#CCC", fontSize:18, flexShrink:0, lineHeight:1 }}>⠿</span>
              <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:"#BBB", width:20, flexShrink:0, textAlign:"center" }}>{idx + 1}</span>
              <div style={{ width:36, height:48, background:"#F0F0EE", borderRadius:3, overflow:"hidden", flexShrink:0 }}>
                {(() => {
                  const t = p.imgs?.[0] || p.colors?.[p.defaultColorIdx ?? 0]?.imgs?.[0];
                  return t
                    ? <img src={t} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt="" draggable={false} />
                    : <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"#CCC", fontSize:16 }}>+</div>;
                })()}
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:14, color:C.ink, marginBottom:2, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{p.name}</p>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted }}>{p.cat}</p>
              </div>
              {p.discountRate > 0 ? (
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, flexShrink:0 }}>
                  <span style={{ color:"#C0392B" }}>₩{Math.round(p.price * (1 - p.discountRate / 100)).toLocaleString()}</span>
                  <span style={{ color:"#CCC", textDecoration:"line-through", marginLeft:5, fontSize:10 }}>₩{p.price.toLocaleString()}</span>
                </span>
              ) : (
                <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted, flexShrink:0 }}>₩{p.price.toLocaleString()}</span>
              )}
            </div>
          ))}
        </div>

        <div style={{ display:"flex", gap:12 }}>
          <button className="adm-btn" onClick={() => setView("list")}
            style={{ background:"#F0F0EE", color:C.ink }}>
            취소
          </button>
          <button className="adm-btn" onClick={doSaveOrder} disabled={orderSaving}
            style={{ background:C.ink, color:"#fff", flex:1, opacity: orderSaving ? 0.6 : 1 }}>
            {orderSaving ? "저장 중..." : "순서 저장"}
          </button>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     Info 페이지 콘텐츠 편집
  ══════════════ */
  if (view === "infoContent" && infoContentForm) return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:860, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:24, fontWeight:400 }}>Info 페이지 콘텐츠</h2>
        </div>
        <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:2, color:C.muted, marginBottom:24, textTransform:"uppercase" }}>
          푸터 Info / Help 링크 클릭 시 표시되는 페이지 내용을 편집합니다
        </p>

        {/* 타입 탭 */}
        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:24 }}>
          {INFO_TYPES.map(t => (
            <button key={t.key} onClick={() => setInfoEditType(t.key)}
              className="adm-btn"
              style={{
                background: infoEditType === t.key ? C.ink : "#fff",
                color: infoEditType === t.key ? "#fff" : C.ink,
                border: `1px solid ${infoEditType === t.key ? C.ink : "#E0E0DE"}`,
                fontSize:11, padding:"7px 16px",
              }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* 선택된 타입 편집 */}
        {infoContentForm[infoEditType] && (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, display:"flex", flexDirection:"column", gap:18 }}>

            {/* 페이지 헤더 */}
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
              <div>
                <label className="adm-label">페이지 제목 (영문)</label>
                <input className="adm-input"
                  value={infoContentForm[infoEditType].title || ""}
                  onChange={e => updateInfoMeta("title", e.target.value)} />
              </div>
              <div>
                <label className="adm-label">부제목 (한글)</label>
                <input className="adm-input"
                  value={infoContentForm[infoEditType].sub || ""}
                  onChange={e => updateInfoMeta("sub", e.target.value)} />
              </div>
            </div>

            <div style={{ height:1, background:"#F0F0EE" }} />

            {/* 섹션 목록 */}
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, textTransform:"uppercase", margin:0 }}>섹션</p>

            {(infoContentForm[infoEditType].sections || []).map((sec, si) => (
              <div key={si} style={{ border:"1px solid #F0F0EE", borderRadius:4, padding:16, display:"flex", flexDirection:"column", gap:10 }}>
                <div style={{ display:"flex", gap:10, alignItems:"center" }}>
                  <input className="adm-input"
                    value={sec.heading || ""}
                    onChange={e => updateInfoSect(si, "heading", e.target.value)}
                    placeholder="소제목" style={{ flex:1 }} />
                  <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted, flexShrink:0 }}>#{si + 1}</span>
                  <button onClick={() => removeInfoSect(si)}
                    style={{ background:"none", border:"1px solid #F0D0CE", color:"#C0392B", borderRadius:3, padding:"5px 10px", cursor:"pointer", fontSize:11, flexShrink:0 }}>삭제</button>
                </div>
                <textarea className="adm-input"
                  value={sec.body || ""}
                  onChange={e => updateInfoSect(si, "body", e.target.value)}
                  rows={4} style={{ resize:"vertical" }}
                  placeholder="내용 (줄바꿈은 Enter)" />
              </div>
            ))}

            <button onClick={addInfoSect}
              style={{ alignSelf:"flex-start", fontFamily:"'Presentation5',sans-serif", fontSize:12, background:"#F0F0EE", color:C.ink, border:"none", padding:"9px 20px", cursor:"pointer", borderRadius:3 }}>
              + 섹션 추가
            </button>
          </div>
        )}

        <div style={{ display:"flex", gap:10, marginTop:20 }}>
          <button onClick={() => setView("list")} className="adm-btn" style={{ background:"#F0F0EE", color:C.ink }}>취소</button>
          <button onClick={doSaveInfoContent} disabled={infoContentSaving}
            className="adm-btn"
            style={{ background:C.ink, color:"#fff", flex:1, fontSize:13, opacity: infoContentSaving ? .6 : 1 }}>
            {infoContentSaving ? "저장 중..." : "저장"}
          </button>
        </div>
      </div>
    </div>
  );

  /* ══════════════
     공지사항 관리
  ══════════════ */
  if (view === "admin-notices") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:900, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:28 }}>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>공지사항 관리</h2>
          {!noticeEditMode && (
            <button onClick={() => { setNoticeForm({ id:null, title:'', content:'', imageUrl:'' }); setNoticeEditMode(true); }}
              className="adm-btn" style={{ background:C.ink, color:"#fff" }}>+ 새 공지 작성</button>
          )}
        </div>

        {noticeEditMode && (
          <form onSubmit={saveNotice} style={{ background:"#fff", border:"1px solid #E8E8E6", padding:28, marginBottom:32, display:"flex", flexDirection:"column", gap:14 }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, fontWeight:600, marginBottom:4 }}>
              {noticeForm.id ? '공지 수정' : '새 공지 작성'}
            </p>
            <div>
              <label className="adm-label">제목 *</label>
              <input className="adm-input" value={noticeForm.title} onChange={e => setNoticeForm(f => ({ ...f, title: e.target.value }))} required placeholder="공지 제목" />
            </div>
            <div>
              <label className="adm-label">내용 *</label>
              <textarea className="adm-input" value={noticeForm.content} onChange={e => setNoticeForm(f => ({ ...f, content: e.target.value }))} required rows={8} style={{ resize:"vertical" }} placeholder="공지 내용" />
            </div>
            <div>
              <label className="adm-label">이미지 (선택)</label>
              <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
                <label style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"8px 16px", border:`1px solid ${C.border}`, cursor:"pointer", fontFamily:"'Pretendard',sans-serif", fontSize:11, color:C.ink }}>
                  {noticeImgUploading ? "업로드 중..." : "이미지 선택"}
                  <input type="file" accept="image/*" style={{ display:"none" }} disabled={noticeImgUploading}
                    onChange={e => uploadNoticeImage(e.target.files[0])} />
                </label>
                {noticeForm.imageUrl && (
                  <>
                    <img src={noticeForm.imageUrl} alt="" style={{ height:80, objectFit:"cover", border:`1px solid ${C.border}` }} />
                    <button type="button" onClick={() => setNoticeForm(f => ({ ...f, imageUrl:'' }))}
                      style={{ fontSize:11, fontFamily:"'Pretendard',sans-serif", background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 10px", cursor:"pointer" }}>
                      이미지 삭제
                    </button>
                  </>
                )}
              </div>
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button type="button" onClick={() => setNoticeEditMode(false)} className="adm-btn" style={{ background:"#F0F0EE", color:C.ink }}>취소</button>
              <button type="submit" disabled={noticeSaving || noticeImgUploading} className="adm-btn" style={{ background:C.ink, color:"#fff", flex:1, opacity: (noticeSaving || noticeImgUploading) ? .6 : 1 }}>
                {noticeSaving ? "저장 중..." : "저장"}
              </button>
            </div>
          </form>
        )}

        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ borderBottom:"2px solid #1A1A1A" }}>
              {["제목","등록일",""].map(h => (
                <th key={h} style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:"#888", padding:"8px 12px", textAlign: h==="제목" ? "left" : "center" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {adminNotices.length === 0 ? (
              <tr><td colSpan={3} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", padding:"32px 12px", textAlign:"center" }}>등록된 공지사항이 없습니다.</td></tr>
            ) : adminNotices.map(n => (
              <tr key={n.id} style={{ borderBottom:"1px solid #F0F0EE" }}>
                <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, padding:"14px 12px", color:C.ink }}>{n.title}</td>
                <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", padding:"14px 12px", textAlign:"center", whiteSpace:"nowrap" }}>{fmtDate(n.created_at)}</td>
                <td style={{ padding:"14px 12px", textAlign:"center", whiteSpace:"nowrap" }}>
                  <button onClick={() => { setNoticeForm({ id:n.id, title:n.title, content:n.content, imageUrl:n.image_url||'' }); setNoticeEditMode(true); }}
                    style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #DDD", padding:"4px 12px", cursor:"pointer", marginRight:6 }}>수정</button>
                  <button onClick={() => deleteNotice(n.id)}
                    style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 12px", cursor:"pointer" }}>삭제</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );

  /* ══════════════
     리뷰 관리
  ══════════════ */
  const RATING_STARS = (n) => "★".repeat(n) + "☆".repeat(5 - n);

  if (view === "admin-reviews") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:980, margin:"0 auto", padding:"40px" }}>
        <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, marginBottom:24 }}>리뷰 관리</h2>

        {selectedReview ? (
          /* ── 상세 + 댓글 ── */
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <button onClick={() => setSelectedReview(null)}
                style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", background:"none", border:"none", cursor:"pointer", padding:0 }}>
                ← 목록으로
              </button>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                <button onClick={() => doToggleBestInManage(selectedReview)} disabled={bestSaving === selectedReview.id}
                  style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, padding:"5px 14px", cursor:"pointer", borderRadius:2,
                    background: selectedReview.is_best ? "#FFF9E6" : "none",
                    border: `1px solid ${selectedReview.is_best ? "#C5A028" : "#DDD"}`,
                    color: selectedReview.is_best ? "#C5A028" : "#666",
                    opacity: bestSaving === selectedReview.id ? .5 : 1 }}>
                  {selectedReview.is_best ? "★ BEST 해제" : "☆ BEST 지정"}
                </button>
                {selectedReview.review_type !== 'text' && !selectedReview.points_granted && (
                  <button onClick={() => doGrantPhotoPoints(selectedReview.id)}
                    style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, padding:"5px 14px", cursor:"pointer", borderRadius:2,
                      background:"#E8F5EC", border:"1px solid #B2D8C5", color:"#2E7D52" }}>
                    적립금 지급 ({selectedReview.review_type === 'wearing_photo' ? '₩3,000' : '₩2,000'})
                  </button>
                )}
                {selectedReview.review_type !== 'text' && selectedReview.points_granted && (
                  <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, padding:"5px 14px", borderRadius:2,
                    background:"#F5F5F5", color:"#888" }}>적립금 지급완료</span>
                )}
                <button onClick={() => doDeleteReview(selectedReview.id)}
                  style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"5px 14px", cursor:"pointer", borderRadius:2 }}>
                  리뷰 삭제
                </button>
              </div>
            </div>

            {/* 리뷰 본문 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", padding:28, marginBottom:20 }}>
              <div style={{ display:"flex", gap:8, flexWrap:"wrap", alignItems:"center", marginBottom:8 }}>
                <span style={{ fontSize:16, color:"#E8A838", letterSpacing:1 }}>{RATING_STARS(selectedReview.rating)}</span>
                {selectedReview.is_best && <span style={{ fontSize:10, padding:"2px 7px", background:"#C5A028", color:"#fff", borderRadius:2 }}>BEST</span>}
                {selectedReview.verified_purchase && <span style={{ fontSize:10, padding:"2px 7px", border:"1px solid #3D8B5C", color:"#3D8B5C", borderRadius:2 }}>구매확인</span>}
              </div>
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:700, fontSize:15, marginBottom:4 }}>{selectedReview.title || "(제목 없음)"}</p>
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", marginBottom:16 }}>
                {products.find(p => p.id === selectedReview.product_id)?.name || "제품 삭제됨"} · {selectedReview.profiles?.name || selectedReview.profiles?.username || "익명"} · {fmtDate(selectedReview.created_at)}
              </p>
              <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, lineHeight:1.9, color:"#333", whiteSpace:"pre-wrap", marginBottom:16 }}>{selectedReview.content}</div>
              {selectedReview.images?.length > 0 && (
                <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
                  {selectedReview.images.map((img, i) => (
                    <img key={i} src={img} alt="" style={{ width:72, height:72, objectFit:"cover", cursor:"pointer" }}
                      onClick={() => window.open(img, "_blank")} />
                  ))}
                </div>
              )}
            </div>

            {/* 관리자 댓글 목록 */}
            {(reviewCommentMap[selectedReview.id] || []).map(c => (
              <div key={c.id} style={{ background:"#F7F5F2", border:"1px solid #E8E8E6", padding:"18px 22px", marginBottom:10, display:"flex", justifyContent:"space-between", gap:16 }}>
                <div style={{ flex:1 }}>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:600, fontSize:10, letterSpacing:1.5, color:C.accent, marginBottom:8 }}>UNDERLOOKED 댓글</p>
                  <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, lineHeight:1.9, whiteSpace:"pre-wrap" }}>{c.content}</div>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color:"#888", marginTop:8 }}>{fmtDate(c.created_at)}</p>
                </div>
                <button onClick={() => removeReviewComment(c.id)}
                  style={{ alignSelf:"flex-start", fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 12px", cursor:"pointer", whiteSpace:"nowrap" }}>삭제</button>
              </div>
            ))}

            {/* 댓글 작성 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", padding:20, marginTop:8 }}>
              <label className="adm-label">관리자 댓글 작성</label>
              <textarea className="adm-input" value={reviewCommentText} onChange={e => setReviewCommentText(e.target.value)}
                rows={4} style={{ resize:"vertical", marginBottom:12 }} placeholder="리뷰에 댓글을 남겨보세요" />
              <button onClick={submitReviewComment} disabled={reviewCommentSaving || !reviewCommentText.trim()} className="adm-btn"
                style={{ background:C.ink, color:"#fff", opacity:(reviewCommentSaving || !reviewCommentText.trim()) ? .5 : 1 }}>
                {reviewCommentSaving ? "등록 중..." : "댓글 등록"}
              </button>
            </div>
          </div>
        ) : (
          /* ── 목록 ── */
          <>
            {/* 필터 탭 */}
            <div style={{ display:"flex", gap:6, marginBottom:16 }}>
              {[{value:"all",label:"전체"},{value:"best",label:"BEST"},{value:"pending",label:"적립금 대기"}].map(f => (
                <button key={f.value} onClick={() => openAdminReviews(0, f.value)}
                  style={{ padding:"5px 14px", border:`1px solid ${reviewListFilter===f.value ? C.ink : "#DDD"}`,
                    background: reviewListFilter===f.value ? C.ink : "transparent",
                    color: reviewListFilter===f.value ? "#fff" : "#666",
                    fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1, cursor:"pointer", borderRadius:2 }}>
                  {f.label}
                </button>
              ))}
              <span style={{ marginLeft:"auto", fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", lineHeight:"28px" }}>
                총 {adminReviewTotal}개
              </span>
            </div>

            {adminReviewLoading ? (
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, color:"#888" }}>불러오는 중...</p>
            ) : (
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr style={{ borderBottom:"2px solid #1A1A1A" }}>
                    {["평점","제품","작성자","내용","유형","BEST","등록일",""].map(h => (
                      <th key={h} style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:1.5, color:"#888", padding:"8px 10px", textAlign: h==="내용" ? "left" : "center", whiteSpace:"nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {adminReviews.length === 0 ? (
                    <tr><td colSpan={8} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", padding:"32px 10px", textAlign:"center" }}>리뷰가 없습니다.</td></tr>
                  ) : adminReviews.map(r => (
                    <tr key={r.id} style={{ borderBottom:"1px solid #F0F0EE", cursor:"pointer" }}
                      onClick={() => openReviewDetail(r)}
                      onMouseEnter={e => e.currentTarget.style.background="#F7F7F5"}
                      onMouseLeave={e => e.currentTarget.style.background="none"}>
                      <td style={{ padding:"12px 10px", textAlign:"center", color:"#E8A838", fontSize:13, whiteSpace:"nowrap" }}>{RATING_STARS(r.rating)}</td>
                      <td style={{ padding:"12px 10px", fontFamily:"'Pretendard',sans-serif", fontSize:12, textAlign:"center", maxWidth:120, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{products.find(p => p.id === r.product_id)?.name || "-"}</td>
                      <td style={{ padding:"12px 10px", fontFamily:"'Pretendard',sans-serif", fontSize:12, textAlign:"center", color:"#666" }}>{r.profiles?.name || r.profiles?.username || "익명"}</td>
                      <td style={{ padding:"12px 10px", fontFamily:"'Pretendard',sans-serif", fontSize:12, maxWidth:200, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
                        {r.title ? <strong style={{ marginRight:4 }}>{r.title}</strong> : null}{r.content}
                      </td>
                      <td style={{ padding:"12px 10px", fontFamily:"'Pretendard',sans-serif", fontSize:11, textAlign:"center", color:"#888" }}>
                        {{text:"텍스트",photo:"포토",wearing_photo:"착용포토"}[r.review_type] || r.review_type}
                        {r.photo_points_pending && !r.points_granted && (
                          <span style={{ display:"block", fontSize:9, color:"#E67E22", marginTop:2 }}>적립금 대기</span>
                        )}
                        {r.review_type !== 'text' && r.points_granted && (
                          <span style={{ display:"block", fontSize:9, color:"#888", marginTop:2 }}>지급완료</span>
                        )}
                      </td>
                      <td style={{ padding:"12px 10px", textAlign:"center" }}>
                        {r.is_best && <span style={{ fontSize:11, color:"#C5A028" }}>★</span>}
                      </td>
                      <td style={{ padding:"12px 10px", fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", textAlign:"center", whiteSpace:"nowrap" }}>{fmtDate(r.created_at)}</td>
                      <td style={{ padding:"12px 10px", textAlign:"center" }}>
                        <button onClick={e => { e.stopPropagation(); doDeleteReview(r.id); }}
                          style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 10px", cursor:"pointer", borderRadius:2 }}>
                          삭제
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* 페이지네이션 */}
            {adminReviewTotal > REVIEW_PAGE_SIZE && (
              <div style={{ display:"flex", justifyContent:"center", gap:6, marginTop:20 }}>
                {Array.from({ length: Math.ceil(adminReviewTotal / REVIEW_PAGE_SIZE) }, (_, i) => (
                  <button key={i} onClick={() => openAdminReviews(i, reviewListFilter)}
                    style={{ width:32, height:32, border:`1px solid ${adminReviewPage === i ? C.ink : "#DDD"}`,
                      background: adminReviewPage === i ? C.ink : "transparent",
                      color: adminReviewPage === i ? "#fff" : "#666",
                      fontFamily:"'Pretendard',sans-serif", fontSize:12, cursor:"pointer", borderRadius:2 }}>
                    {i + 1}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );

  /* ══════════════
     문의 관리
  ══════════════ */
  if (view === "admin-inquiries") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:900, margin:"0 auto", padding:"40px" }}>
        <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, marginBottom:28 }}>문의 관리</h2>

        {selectedInquiry ? (
          <div>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
              <button onClick={() => setSelectedInquiry(null)}
                style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", background:"none", border:"none", cursor:"pointer", padding:0 }}>
                ← 목록으로
              </button>
              <button onClick={() => deleteInquiry(selectedInquiry.id)}
                style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"5px 14px", cursor:"pointer", borderRadius:2 }}>
                문의 삭제
              </button>
            </div>
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", padding:28, marginBottom:20 }}>
              <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
                <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:700, fontSize:16, color:C.ink }}>{selectedInquiry.title}</p>
                <span style={{ fontSize:10, fontFamily:"'Pretendard',sans-serif", padding:"2px 8px", background: selectedInquiry.is_public ? "#E8EEF8" : "#F5F5F5", color: selectedInquiry.is_public ? "#2C5282" : "#888", border:`1px solid ${selectedInquiry.is_public ? "#B2C8E8" : "#DDD"}` }}>
                  {selectedInquiry.is_public ? "공개" : "비공개"}
                </span>
                <span style={{ fontSize:10, fontFamily:"'Pretendard',sans-serif", padding:"2px 8px", background: selectedInquiry.status === "answered" ? "#E6F4ED" : "#F5F5F5", color: selectedInquiry.status === "answered" ? "#2E7D52" : "#888", border:`1px solid ${selectedInquiry.status === "answered" ? "#B2D8C5" : "#DDD"}` }}>
                  {selectedInquiry.status === "answered" ? "답변 완료" : "답변 대기"}
                </span>
              </div>
              <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", marginBottom:20 }}>{fmtDate(selectedInquiry.created_at)}</p>
              <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, lineHeight:1.9, color:"#333", whiteSpace:"pre-wrap" }}>{selectedInquiry.content}</div>
            </div>

            {(inquiryReplies[selectedInquiry.id] || []).map(r => (
              <div key={r.id} style={{ background:"#F7F5F2", border:"1px solid #E8E8E6", padding:"20px 24px", marginBottom:12, display:"flex", justifyContent:"space-between", gap:16 }}>
                <div style={{ flex:1 }}>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:600, fontSize:11, letterSpacing:1.5, color:C.accent, marginBottom:10 }}>UNDERLOOKED 답변</p>
                  <div style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, lineHeight:1.9, whiteSpace:"pre-wrap" }}>{r.content}</div>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, color:"#888", marginTop:10 }}>{fmtDate(r.created_at)}</p>
                </div>
                <button onClick={() => deleteReply(r.id, selectedInquiry.id)}
                  style={{ alignSelf:"flex-start", fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 12px", cursor:"pointer", whiteSpace:"nowrap" }}>삭제</button>
              </div>
            ))}

            <div style={{ background:"#fff", border:"1px solid #E8E8E6", padding:20, marginTop:8 }}>
              <label className="adm-label">답변 작성</label>
              <textarea className="adm-input" value={replyContent} onChange={e => setReplyContent(e.target.value)} rows={5} style={{ resize:"vertical", marginBottom:12 }} placeholder="답변 내용을 입력하세요" />
              <button onClick={submitReply} disabled={replySaving || !replyContent.trim()} className="adm-btn"
                style={{ background:C.ink, color:"#fff", opacity: (replySaving || !replyContent.trim()) ? .5 : 1 }}>
                {replySaving ? "등록 중..." : "답변 등록"}
              </button>
            </div>
          </div>
        ) : (
          <>
          {/* 필터 탭 */}
          <div style={{ display:"flex", gap:6, marginBottom:16 }}>
            {[{value:"all",label:"전체"},{value:"pending",label:"답변 대기"},{value:"answered",label:"답변 완료"}].map(f => (
              <button key={f.value} onClick={() => setInquiryFilter(f.value)}
                style={{ padding:"5px 14px", border:`1px solid ${inquiryFilter===f.value ? C.ink : "#DDD"}`,
                  background: inquiryFilter===f.value ? C.ink : "transparent",
                  color: inquiryFilter===f.value ? "#fff" : "#666",
                  fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1, cursor:"pointer", borderRadius:2 }}>
                {f.label}
                {f.value !== "all" && (
                  <span style={{ marginLeft:6, opacity:.7 }}>
                    ({adminInquiries.filter(i => i.status === f.value).length})
                  </span>
                )}
              </button>
            ))}
          </div>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ borderBottom:"2px solid #1A1A1A" }}>
                {["제목","공개","상태","등록일",""].map(h => (
                  <th key={h} style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:"#888", padding:"8px 12px", textAlign: h==="제목" ? "left" : "center" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(() => {
                const filtered = inquiryFilter === "all" ? adminInquiries : adminInquiries.filter(i => i.status === inquiryFilter);
                return filtered.length === 0 ? (
                  <tr><td colSpan={5} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", padding:"32px 12px", textAlign:"center" }}>해당 문의가 없습니다.</td></tr>
                ) : filtered.map(inq => (
                <tr key={inq.id} style={{ borderBottom:"1px solid #F0F0EE", cursor:"pointer" }}
                  onClick={() => openInquiryDetail(inq)}
                  onMouseEnter={e => e.currentTarget.style.background="#F7F7F5"}
                  onMouseLeave={e => e.currentTarget.style.background="none"}>
                  <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, padding:"14px 12px", color:C.ink }}>
                    {!inq.is_public && <span style={{ fontSize:10, marginRight:6 }}>🔒</span>}
                    {inq.title}
                  </td>
                  <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", padding:"14px 12px", textAlign:"center" }}>{inq.is_public ? "공개" : "비공개"}</td>
                  <td style={{ padding:"14px 12px", textAlign:"center" }}>
                    <span style={{ fontSize:10, fontFamily:"'Pretendard',sans-serif", padding:"2px 8px", background: inq.status === "answered" ? "#E6F4ED" : "#F5F5F5", color: inq.status === "answered" ? "#2E7D52" : "#888", border:`1px solid ${inq.status === "answered" ? "#B2D8C5" : "#DDD"}` }}>
                      {inq.status === "answered" ? "답변 완료" : "답변 대기"}
                    </span>
                  </td>
                  <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", padding:"14px 12px", textAlign:"center", whiteSpace:"nowrap" }}>{fmtDate(inq.created_at)}</td>
                  <td style={{ padding:"14px 12px", textAlign:"center" }}>
                    <button onClick={e => { e.stopPropagation(); deleteInquiry(inq.id); }}
                      style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"4px 12px", cursor:"pointer", borderRadius:2, whiteSpace:"nowrap" }}>
                      삭제
                    </button>
                  </td>
                </tr>
              ));
              })()}
            </tbody>
          </table>
          </>
        )}
      </div>
    </div>
  );

  /* ══════════════
     적립금 현황
  ══════════════ */
  if (view === "points-admin") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1000, margin:"0 auto", padding:"40px" }}>
        <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, marginBottom:24 }}>적립금 현황</h2>

        {/* 요약 카드 */}
        {pointSummary && (
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14, marginBottom:28 }}>
            {[
              { label:"총 지급", value: pointSummary.totalEarned, color:"#2E7D52" },
              { label:"총 사용", value: pointSummary.totalUsed,   color:"#C0392B" },
              { label:"유통 중", value: pointSummary.available,    color: C.accent },
            ].map(card => (
              <div key={card.label} style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"20px 24px" }}>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:9, letterSpacing:3, color:"#888", marginBottom:8, textTransform:"uppercase" }}>{card.label}</p>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, color: card.color }}>
                  ₩{card.value.toLocaleString()}
                </p>
              </div>
            ))}
          </div>
        )}

        {/* 적립금 지급 폼 */}
        <form onSubmit={handleAdminGrantPoints} style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"20px 24px", marginBottom:24 }}>
          <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, letterSpacing:2, marginBottom:14 }}>적립금 지급 / 차감</p>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 120px 1fr auto", gap:10, alignItems:"end" }}>
            <div>
              <label style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:1, color:"#888", display:"block", marginBottom:4 }}>회원 이메일</label>
              <input className="adm-input" value={grantEmail} onChange={e => setGrantEmail(e.target.value)}
                placeholder="user@email.com" required />
            </div>
            <div>
              <label style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:1, color:"#888", display:"block", marginBottom:4 }}>금액 (음수=차감)</label>
              <input className="adm-input" type="number" value={grantAmount} onChange={e => setGrantAmount(e.target.value)}
                placeholder="1000" required />
            </div>
            <div>
              <label style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, letterSpacing:1, color:"#888", display:"block", marginBottom:4 }}>사유</label>
              <input className="adm-input" value={grantDesc} onChange={e => setGrantDesc(e.target.value)}
                placeholder="이벤트 적립금 지급" required />
            </div>
            <button type="submit" disabled={grantSaving}
              style={{ padding:"9px 18px", background:C.ink, color:"#fff", border:"none", cursor:"pointer",
                fontFamily:"'Presentation5',sans-serif", fontSize:11, letterSpacing:1, borderRadius:3,
                opacity: grantSaving ? .6 : 1, whiteSpace:"nowrap" }}>
              {grantSaving ? "처리 중..." : "지급"}
            </button>
          </div>
          {grantMsg && (
            <p style={{ marginTop:10, fontFamily:"'Pretendard',sans-serif", fontSize:12,
              color: grantMsg.type === 'ok' ? '#2E7D52' : '#C0392B' }}>
              {grantMsg.text}
            </p>
          )}
        </form>

        {/* 필터 탭 */}
        <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
          {POINT_TYPE_OPTS.map(opt => (
            <button key={String(opt.value)} onClick={() => openPointsAdmin(0, opt.value)}
              style={{ padding:"5px 14px", border:`1px solid ${pointTxFilter===opt.value ? C.ink : "#DDD"}`,
                background: pointTxFilter===opt.value ? C.ink : "transparent",
                color: pointTxFilter===opt.value ? "#fff" : "#666",
                fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1, cursor:"pointer", borderRadius:2 }}>
              {opt.label}
            </button>
          ))}
          <span style={{ marginLeft:"auto", fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", lineHeight:"28px" }}>
            총 {pointTxTotal.toLocaleString()}건
          </span>
        </div>

        {pointTxLoading ? (
          <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, color:"#888" }}>불러오는 중...</p>
        ) : (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, overflow:"hidden" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ borderBottom:"1px solid #F0F0EE", background:"#FAFAF8" }}>
                  {["회원","유형","내용","금액","날짜",""].map(h => (
                    <th key={h} style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:1.5, color:"#888", padding:"10px 14px", textAlign: h==="금액" ? "right" : h==="내용" ? "left" : "center" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pointTxs.length === 0 ? (
                  <tr><td colSpan={6} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", padding:"32px", textAlign:"center" }}>내역이 없습니다.</td></tr>
                ) : pointTxs.map(tx => (
                  <tr key={tx.id} style={{ borderBottom:"1px solid #F5F5F3" }}>
                    <td style={{ padding:"10px 14px", textAlign:"center", fontFamily:"'Pretendard',sans-serif", fontSize:12 }}>
                      {tx.profiles?.name || tx.profiles?.username || <span style={{ color:"#BBB" }}>-</span>}
                    </td>
                    <td style={{ padding:"10px 14px", textAlign:"center" }}>
                      <span style={{ fontSize:10, fontFamily:"'Presentation5',sans-serif", letterSpacing:1, padding:"2px 8px", borderRadius:2,
                        background: tx.amount > 0 ? "#E8F5EC" : "#FFF0F0",
                        color:      tx.amount > 0 ? "#2E7D52" : "#C0392B" }}>
                        {tx.typeLabel}
                      </span>
                    </td>
                    <td style={{ padding:"10px 14px", fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#555" }}>{tx.description}</td>
                    <td style={{ padding:"10px 14px", textAlign:"right", fontFamily:"'Presentation5',sans-serif", fontWeight:600, fontSize:13,
                      color: tx.amount > 0 ? "#2E7D52" : "#C0392B" }}>
                      {tx.amount > 0 ? "+" : ""}₩{tx.amount.toLocaleString()}
                    </td>
                    <td style={{ padding:"10px 14px", textAlign:"center", fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#888", whiteSpace:"nowrap" }}>
                      {fmtDate(tx.created_at)}
                    </td>
                    <td style={{ padding:"10px 8px", textAlign:"center" }}>
                      <button onClick={() => handleDeletePointTx(tx.id)}
                        style={{ background:"none", border:"1px solid #E0DCDA", borderRadius:3, padding:"3px 8px",
                          fontFamily:"'Pretendard',sans-serif", fontSize:10, color:"#C94040", cursor:"pointer" }}>
                        삭제
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* 페이지네이션 */}
        {pointTxTotal > POINTS_PAGE_SIZE && (
          <div style={{ display:"flex", justifyContent:"center", gap:6, marginTop:20 }}>
            {Array.from({ length: Math.ceil(pointTxTotal / POINTS_PAGE_SIZE) }, (_, i) => (
              <button key={i} onClick={() => openPointsAdmin(i, pointTxFilter)}
                style={{ width:32, height:32, border:`1px solid ${pointTxPage===i ? C.ink : "#DDD"}`,
                  background: pointTxPage===i ? C.ink : "transparent",
                  color: pointTxPage===i ? "#fff" : "#666",
                  fontFamily:"'Pretendard',sans-serif", fontSize:12, cursor:"pointer", borderRadius:2 }}>
                {i + 1}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  /* ══════════════
     회원 목록
  ══════════════ */
  if (view === "members") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1000, margin:"0 auto", padding:"40px" }}>
        <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, marginBottom:28 }}>회원 목록</h2>
        {membersLoading ? (
          <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, color:"#888" }}>불러오는 중...</p>
        ) : (
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ borderBottom:"2px solid #1A1A1A" }}>
                {["가입유형","아이디","이름","이메일","가입일","관리자"].map(h => (
                  <th key={h} style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:"#888", padding:"8px 12px", textAlign:"center" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {members.length === 0 ? (
                <tr><td colSpan={6} style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, color:"#888", padding:"32px 12px", textAlign:"center" }}>회원이 없습니다.</td></tr>
              ) : members.map(m => {
                const badge = providerBadge(m.provider);
                return (
                  <tr key={m.id} style={{ borderBottom:"1px solid #F0F0EE" }}>
                    <td style={{ padding:"12px", textAlign:"center" }}>
                      <span style={{ display:"inline-flex", alignItems:"center", justifyContent:"center", width:22, height:22, borderRadius:"50%", background:badge.bg, color:badge.color, fontFamily:"'Pretendard',sans-serif", fontWeight:700, fontSize:11 }}>{badge.label}</span>
                    </td>
                    <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, padding:"12px", textAlign:"center", color:C.ink }}>{m.username || '-'}</td>
                    <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:12, padding:"12px", textAlign:"center" }}>{m.name || '-'}</td>
                    <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, padding:"12px", textAlign:"center", color:"#888" }}>{m.email || '-'}</td>
                    <td style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, padding:"12px", textAlign:"center", color:"#888", whiteSpace:"nowrap" }}>{fmtDate(m.created_at)}</td>
                    <td style={{ padding:"12px", textAlign:"center" }}>
                      {m.is_admin && <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:10, padding:"2px 8px", background:"#FFF3E0", color:"#E65100", border:"1px solid #FFCC80" }}>관리자</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );

  /* ══════════════
     재고 관리
  ══════════════ */
  if (view === "inventory") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:860, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:28 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
            <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>재고 관리</h2>
          </div>
        </div>

        {/* 상품 선택 */}
        <div style={{ marginBottom:24 }}>
          <label className="adm-label">상품 선택</label>
          <select className="adm-input" style={{ maxWidth:360 }}
            value={inventoryProduct || ""} onChange={e => openInventory(e.target.value ? parseInt(e.target.value) : null)}>
            <option value="">-- 상품을 선택하세요 --</option>
            {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </div>

        {inventoryProduct && (
          <>
            {/* 재고 행 추가 폼 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:20, marginBottom:20 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.muted, marginBottom:16, textTransform:"uppercase" }}>재고 행 추가</p>
              <div style={{ display:"flex", gap:10, flexWrap:"wrap", alignItems:"flex-end" }}>
                <div>
                  <label className="adm-label">사이즈</label>
                  <input className="adm-input" style={{ width:100 }} placeholder="S / M / L / FREE"
                    value={inventoryForm.size} onChange={e => setInventoryForm(f => ({ ...f, size: e.target.value }))} />
                </div>
                <div>
                  <label className="adm-label">색상명</label>
                  <input className="adm-input" style={{ width:140 }} placeholder="Black / 없으면 빈칸"
                    value={inventoryForm.color_name} onChange={e => setInventoryForm(f => ({ ...f, color_name: e.target.value }))} />
                </div>
                <div>
                  <label className="adm-label">수량</label>
                  <input className="adm-input" style={{ width:90 }} type="number" min="0" placeholder="0"
                    value={inventoryForm.quantity} onChange={e => setInventoryForm(f => ({ ...f, quantity: e.target.value }))} />
                </div>
                <button className="adm-btn" onClick={doUpsertInventory} disabled={inventoryLoading}
                  style={{ background:C.ink, color:"#fff", opacity: inventoryLoading ? .6 : 1, marginBottom:1 }}>
                  {inventoryLoading ? "저장 중..." : "추가 / 수정"}
                </button>
              </div>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted, marginTop:8 }}>
                사이즈+색상이 같은 행이 이미 있으면 수량을 덮어씁니다.
              </p>
            </div>

            {/* 재고 목록 */}
            {inventoryLoading && inventoryRows.length === 0 ? (
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>불러오는 중...</p>
            ) : inventoryRows.length === 0 ? (
              <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"40px 0", textAlign:"center" }}>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>등록된 재고가 없습니다.</p>
              </div>
            ) : (
              <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, overflow:"hidden" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead>
                    <tr style={{ borderBottom:"2px solid #1A1A1A" }}>
                      {["사이즈","색상명","수량",""].map(h => (
                        <th key={h} style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted, padding:"10px 16px", textAlign: h==="" ? "center" : "left" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {inventoryRows.map(row => (
                      <tr key={row.id} style={{ borderBottom:"1px solid #F0F0EE" }}>
                        <td style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, padding:"12px 16px" }}>{row.size || "-"}</td>
                        <td style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, padding:"12px 16px", color:C.muted }}>{row.color_name || "-"}</td>
                        <td style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, padding:"12px 16px", fontWeight: row.quantity === 0 ? 500 : 400, color: row.quantity === 0 ? "#C0392B" : C.ink }}>
                          {row.quantity === 0 ? "품절 (0)" : row.quantity}
                        </td>
                        <td style={{ padding:"12px 16px", textAlign:"center" }}>
                          <button onClick={() => doDeleteInventory(row.id)}
                            style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, background:"none", border:"1px solid #FFCCCC", color:"#C0392B", padding:"3px 10px", cursor:"pointer", borderRadius:2 }}>
                            삭제
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );

  /* ══════════════
     베스트 리뷰
  ══════════════ */
  if (view === "best-reviews") return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:860, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:28 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12 }}>
            <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:10, letterSpacing:2, color:C.muted }}>← 목록으로</button>
            <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600 }}>베스트 리뷰 관리</h2>
          </div>
          <button onClick={openBestReviews} style={{ background:"#F0F0EE", color:C.ink, fontFamily:"'Presentation5',sans-serif", fontSize:11, border:"none", padding:"8px 16px", cursor:"pointer", borderRadius:3 }}>새로고침</button>
        </div>

        {reviewsLoading ? (
          <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.muted }}>불러오는 중...</p>
        ) : allReviews.length === 0 ? (
          <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"60px 0", textAlign:"center" }}>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>등록된 리뷰가 없습니다.</p>
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
            {allReviews.map(rv => (
              <div key={rv.id} style={{ background:"#fff", border:`1px solid ${rv.is_best ? "#C5A028" : "#E8E8E6"}`, borderRadius:6, padding:"16px 20px", display:"flex", gap:14, alignItems:"flex-start" }}>
                {rv.is_best && (
                  <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:9, letterSpacing:1.5, color:"#C5A028", border:"1px solid #C5A028", padding:"2px 7px", borderRadius:2, flexShrink:0, marginTop:2 }}>BEST</span>
                )}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:4 }}>
                    <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, color:C.ink, fontWeight:500 }}>
                      {rv.review_type === "wearing_photo" ? "착용 포토" : rv.review_type === "photo" ? "포토" : "텍스트"}
                    </span>
                    <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted }}>
                      상품 #{rv.product_id}
                    </span>
                    <span style={{ fontFamily:"'Presentation5',sans-serif", fontSize:10, color:C.muted }}>
                      {fmtDate(rv.created_at)}
                    </span>
                  </div>
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:13, color:C.ink, marginBottom:4, lineHeight:1.7 }}>
                    {rv.comment}
                  </p>
                  {rv.rating && (
                    <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted }}>
                      {"★".repeat(rv.rating)}{"☆".repeat(5 - rv.rating)}
                    </p>
                  )}
                </div>
                <button onClick={() => doToggleBest(rv.id, rv.is_best)}
                  disabled={bestSaving === rv.id}
                  style={{
                    flexShrink:0, fontFamily:"'Presentation5',sans-serif", fontSize:10, letterSpacing:1,
                    border:`1px solid ${rv.is_best ? "#C0392B" : "#C5A028"}`,
                    background: rv.is_best ? "transparent" : "#C5A028",
                    color: rv.is_best ? "#C0392B" : "#fff",
                    padding:"5px 12px", cursor:"pointer", borderRadius:2,
                    opacity: bestSaving === rv.id ? .5 : 1,
                  }}>
                  {bestSaving === rv.id ? "..." : rv.is_best ? "베스트 해제" : "베스트 지정"}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  /* ══════════════
     편집 / 추가
  ══════════════ */
  if (!form) return null;

  return (
    <div style={{ minHeight:"100vh", background:F.bg, paddingLeft:220 }}>
      <AdminHeader />
      <div style={{ maxWidth:1100, margin:"0 auto", padding:"40px" }}>
        <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:28 }}>
          <button onClick={() => setView("list")} style={{ background:"none", border:"none", cursor:"pointer", fontFamily:"'Presentation5',sans-serif", fontSize:13, color:C.muted }}>← 목록으로</button>
          <h2 style={{ fontFamily:"'Presentation5',sans-serif", fontSize:22, fontWeight:600, letterSpacing:"-0.3px" }}>{view === "add" ? "새 제품 추가" : "제품 수정"}</h2>
        </div>

        {/* URL 미리보기 */}
        <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:"14px 20px", marginBottom:24, display:"flex", alignItems:"center", gap:12 }}>
          <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:11, letterSpacing:2, color:C.muted, textTransform:"uppercase" }}>URL</span>
          <span style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:12, color:C.ink }}>
            {origin}/product/<strong>{form.slug || toSlug(form.name) || "product-slug"}</strong>
          </span>
          {(form.slug || form.name) && (
            <button onClick={() => copyUrl(form.slug || toSlug(form.name))} style={{ background:"none", border:"none", cursor:"pointer", color: copied===(form.slug||toSlug(form.name)) ? C.accent : "#BBB", fontSize:13, marginLeft:"auto" }}
              title="URL 복사">{copied===(form.slug||toSlug(form.name)) ? "✓ 복사됨" : "⧉ 복사"}</button>
          )}
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:32, alignItems:"start" }}>
          {/* 좌측 */}
          <div style={{ display:"flex", flexDirection:"column", gap:18 }}>
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, display:"flex", flexDirection:"column", gap:18 }}>

              <AdmInput label="제품명 *" value={form.name}
                onChange={e => setForm(p => ({ ...p, name: e.target.value, slug: p.slug || toSlug(e.target.value) }))}
                placeholder="제품명 입력" />

              <AdmInput label="URL Slug" value={form.slug}
                onChange={e => setForm(p => ({ ...p, slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g,"") }))}
                placeholder="product-url-slug" />

              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <div>
                  <label className="adm-label">대분류</label>
                  <select className="adm-input" value={form.cat}
                    onChange={e => setForm(p => ({ ...p, cat: e.target.value, subcat: "" }))}>
                    {(navCats
                      ? [...new Set(navCats.map(c => c.catFilter))]
                      : ["Top", "Bottom", "Outwear"]
                    ).map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                </div>
                <div>
                  <label className="adm-label">소분류</label>
                  {(() => {
                    const opts = (navCats || [])
                      .filter(c => c.catFilter === form.cat)
                      .flatMap(c => c.items.map(it => typeof it === "string" ? it : it.filter))
                      .filter(Boolean);
                    return opts.length > 0 ? (
                      <select className="adm-input" value={form.subcat || ""}
                        onChange={e => setForm(p => ({ ...p, subcat: e.target.value }))}>
                        <option value="">선택 안함</option>
                        {opts.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    ) : (
                      <input className="adm-input" value={form.subcat || ""}
                        onChange={e => setForm(p => ({ ...p, subcat: e.target.value }))}
                        placeholder="메뉴 설정에서 소분류를 먼저 추가하세요" />
                    );
                  })()}
                </div>
              </div>

              <div>
                <label className="adm-label">태그</label>
                <select className="adm-input" value={form.tag || ""} onChange={e => setForm(p => ({ ...p, tag: e.target.value || null }))}>
                  <option value="">없음</option><option>NEW</option><option>BEST</option>
                </select>
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <AdmInput label="가격 (₩)" type="number" value={form.price}
                  onChange={e => setForm(p => ({ ...p, price: e.target.value }))} placeholder="0" />
                <div>
                  <label className="adm-label">할인율 (%)</label>
                  <input className="adm-input" type="number" min="0" max="99" value={form.discountRate || 0}
                    onChange={e => setForm(p => ({ ...p, discountRate: e.target.value }))} placeholder="0" />
                  {parseInt(form.discountRate) > 0 && (
                    <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#C97A3D", marginTop:5 }}>
                      판매가: ₩{Math.round(parseInt(form.price || 0) * (1 - parseInt(form.discountRate) / 100)).toLocaleString()}
                    </p>
                  )}
                </div>
              </div>

              {/* 배송비 */}
              <div>
                <label className="adm-label">배송비</label>
                <div style={{ display:"flex", gap:10, marginTop:6, marginBottom: parseInt(form.shippingFee) > 0 ? 0 : 0 }}>
                  <button type="button"
                    onClick={() => setForm(p => ({ ...p, shippingFee: 0 }))}
                    style={{
                      flex:1, padding:"9px 0", borderRadius:3, fontSize:12, fontFamily:"'Pretendard',sans-serif", fontWeight:500, cursor:"pointer", transition:"all .15s",
                      background: parseInt(form.shippingFee) === 0 ? "#3D8B5C" : "transparent",
                      color:      parseInt(form.shippingFee) === 0 ? "#fff" : "#888",
                      border:     `1px solid ${parseInt(form.shippingFee) === 0 ? "#3D8B5C" : "#DDD"}`,
                    }}>
                    무료배송
                  </button>
                  <button type="button"
                    onClick={() => setForm(p => ({ ...p, shippingFee: p.shippingFee > 0 ? p.shippingFee : 3000 }))}
                    style={{
                      flex:1, padding:"9px 0", borderRadius:3, fontSize:12, fontFamily:"'Pretendard',sans-serif", fontWeight:500, cursor:"pointer", transition:"all .15s",
                      background: parseInt(form.shippingFee) > 0 ? C.ink : "transparent",
                      color:      parseInt(form.shippingFee) > 0 ? "#fff" : "#888",
                      border:     `1px solid ${parseInt(form.shippingFee) > 0 ? C.ink : "#DDD"}`,
                    }}>
                    배송비 있음
                  </button>
                </div>
                {parseInt(form.shippingFee) > 0 && (
                  <div style={{ marginTop:8 }}>
                    <input className="adm-input" type="number" min="0" step="500"
                      value={form.shippingFee}
                      onChange={e => setForm(p => ({ ...p, shippingFee: e.target.value }))}
                      placeholder="배송비 (₩)" />
                    <p style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:C.muted, marginTop:4 }}>
                      배송비: ₩{parseInt(form.shippingFee || 0).toLocaleString()}
                    </p>
                  </div>
                )}
              </div>

              <div>
                <label className="adm-label">사이즈</label>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:6 }}>
                  {ALL_SIZES.map(sz => (
                    <button key={sz} onClick={() => toggleSize(sz)} style={{
                      fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:11, letterSpacing:1,
                      width:48, height:40, borderRadius:3,
                      border:`1px solid ${form.sizes.includes(sz) ? C.ink : "#DDD"}`,
                      background: form.sizes.includes(sz) ? C.ink : "transparent",
                      color: form.sizes.includes(sz) ? "#fff" : "#AAA",
                      cursor:"pointer", transition:"all .15s",
                    }}>{sz}</button>
                  ))}
                </div>
              </div>
            </div>

            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, display:"flex", flexDirection:"column", gap:18 }}>
              <div>
                <label className="adm-label">제품 설명</label>
                <textarea className="adm-input" value={form.desc}
                  onChange={e => setForm(p => ({ ...p, desc: e.target.value }))}
                  rows={4} style={{ resize:"vertical" }} placeholder="제품 설명을 입력하세요" />
              </div>
              <AdmInput label="소재 / Fabric" value={form.fabric}
                onChange={e => setForm(p => ({ ...p, fabric: e.target.value }))}
                placeholder="예: 100% Cotton (400gsm)" />
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14 }}>
                <AdmInput label="원산지" value={form.origin}
                  onChange={e => setForm(p => ({ ...p, origin: e.target.value }))}
                  placeholder="예: Made in Korea" />
                <AdmInput label="핏 / Fit" value={form.fit}
                  onChange={e => setForm(p => ({ ...p, fit: e.target.value }))}
                  placeholder="예: Oversized Box Fit" />
              </div>
              <div>
                <AdmInput label="네이버 스토어 URL" value={form.naverUrl}
                  onChange={e => setForm(p => ({ ...p, naverUrl: e.target.value }))}
                  placeholder="https://smartstore.naver.com/..." />
                <label style={{ display:"flex", alignItems:"center", gap:8, marginTop:8, cursor:"pointer" }}>
                  <input type="checkbox" checked={!!form.naverUrlVisible}
                    onChange={e => setForm(p => ({ ...p, naverUrlVisible: e.target.checked }))}
                    style={{ accentColor:"#222", width:14, height:14 }} />
                  <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:11, color:"#555" }}>상품 페이지에 네이버 스토어 버튼 표시</span>
                </label>
              </div>
            </div>

            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24, display:"flex", flexDirection:"column", gap:18 }}>
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:"#AAA", textTransform:"uppercase", margin:0 }}>상세페이지 — 섹션 내용</p>
              <div>
                <label className="adm-label">Fabric &amp; Care</label>
                <textarea className="adm-input" value={form.fabricCare}
                  onChange={e => setForm(p => ({ ...p, fabricCare: e.target.value }))}
                  rows={4} style={{ resize:"vertical" }} />
              </div>
              <div>
                <label className="adm-label">Fit &amp; Sizing</label>
                <textarea className="adm-input" value={form.fitSizing}
                  onChange={e => setForm(p => ({ ...p, fitSizing: e.target.value }))}
                  rows={4} style={{ resize:"vertical" }} />
              </div>
              <div>
                <label className="adm-label">Shipping &amp; Returns</label>
                <textarea className="adm-input" value={form.shippingReturns}
                  onChange={e => setForm(p => ({ ...p, shippingReturns: e.target.value }))}
                  rows={4} style={{ resize:"vertical" }} />
              </div>
            </div>

            {/* 사이즈 가이드 이미지 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24 }}>
              <label className="adm-label" style={{ marginBottom:14, display:"block", fontSize:13 }}>사이즈 가이드 이미지</label>
              {form.sizeGuideImg ? (
                <div style={{ position:"relative" }}>
                  <img src={form.sizeGuideImg} alt="" style={{ width:"100%", maxHeight:280, objectFit:"contain", display:"block", borderRadius:4, border:"1px solid #DDD", background:"#F5F5F3" }} />
                  <button onClick={() => setForm(p => ({ ...p, sizeGuideImg: null }))}
                    style={{ position:"absolute", top:6, right:6, background:"rgba(0,0,0,0.55)", border:"none", color:"#fff", fontSize:13, cursor:"pointer", borderRadius:"50%", width:26, height:26 }}>×</button>
                </div>
              ) : (
                <label style={{ display:"block", border:"2px dashed #DDD", borderRadius:4, padding:"28px 0", textAlign:"center", cursor:"pointer", color:C.muted, fontSize:12 }}>
                  클릭하여 이미지 업로드
                  <input type="file" accept="image/*" style={{ display:"none" }} onChange={e => {
                    const file = e.target.files?.[0];
                    if (!file) return;
                    const reader = new FileReader();
                    reader.onload = ev => setForm(p => ({ ...p, sizeGuideImg: ev.target.result }));
                    reader.readAsDataURL(file);
                  }} />
                </label>
              )}
              <p style={{ fontSize:11, color:C.muted, marginTop:8, lineHeight:1.6 }}>상세 페이지 "Size Guide →" 클릭 시 이 이미지가 팝업으로 표시됩니다.</p>
            </div>
          </div>

          {/* 우측 — 이미지 + 컬러 */}
          <div style={{ display:"flex", flexDirection:"column", gap:18 }}>

            {/* 기본 이미지 — 항상 표시 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24 }}>
              <label className="adm-label" style={{ marginBottom:16 }}>기본 이미지 (썸네일 · 4장)</label>
              <ImgGrid imgs={form.imgs} onImg={handleImg} onRemoveImg={handleRemoveImg} count={4} />
              <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, letterSpacing:0, marginTop:14, lineHeight:1.8 }}>
                JPG · PNG · WEBP 지원 · 상품 목록 썸네일로 사용됩니다
              </p>
            </div>

            {/* 컬러 없을 때만: 추가 제품 이미지 */}
            {form.colors.length === 0 && (
              <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24 }}>
                <label className="adm-label" style={{ marginBottom:16 }}>상세 이미지 (최대 20장)</label>
                <DynamicImgGrid imgs={form.galleryImgs} onImg={handleGalleryImg} onRemoveImg={handleRemoveGalleryImg} maxCount={20} />
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:C.muted, letterSpacing:0, marginTop:14, lineHeight:1.8 }}>
                  JPG · PNG · WEBP 지원 · 상세페이지 갤러리에 표시됩니다
                </p>
              </div>
            )}

            {/* 컬러 옵션 */}
            <div style={{ background:"#fff", border:"1px solid #E8E8E6", borderRadius:6, padding:24 }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:form.colors.length ? 20 : 0 }}>
                <label className="adm-label" style={{ margin:0 }}>컬러 옵션 ({form.colors.length})</label>
                <button onClick={addColor} style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, fontWeight:500, background:C.ink, color:"#fff", border:"none", padding:"7px 16px", cursor:"pointer", borderRadius:3 }}>
                  + 컬러 추가
                </button>
              </div>

              {form.colors.length === 0 && (
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:11, color:"#AAA", letterSpacing:0, marginTop:14 }}>
                  컬러 추가 시 각 컬러별 기본이미지·상세이미지를 등록하고, 기본 컬러를 선택할 수 있습니다
                </p>
              )}

              {form.colors.map((col, ci) => (
                <div key={ci} style={{ borderTop:"1px solid #F0F0EE", paddingTop:20, marginTop: ci === 0 ? 0 : 20 }}>
                  {/* 컬러 헤더 */}
                  <div style={{ display:"flex", gap:8, alignItems:"center", marginBottom:14, flexWrap:"wrap" }}>
                    <div style={{ position:"relative", flexShrink:0 }}>
                      <div style={{ width:32, height:32, borderRadius:"50%", background:col.hex, border:"1px solid #E0E0DE", cursor:"pointer", overflow:"hidden" }}>
                        <input type="color" value={col.hex}
                          onChange={e => updateColor(ci, "hex", e.target.value)}
                          style={{ opacity:0, position:"absolute", inset:0, width:"100%", height:"100%", cursor:"pointer", border:"none" }} />
                      </div>
                    </div>
                    <input className="adm-input" value={col.name}
                      onChange={e => updateColor(ci, "name", e.target.value)}
                      placeholder="컬러명 (예: Black, Ivory)"
                      style={{ flex:1, minWidth:80 }} />
                    <button
                      onClick={() => setForm(p => ({ ...p, defaultColorIdx: ci }))}
                      style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, padding:"5px 12px", borderRadius:3, cursor:"pointer", flexShrink:0, transition:"all .15s",
                        background: form.defaultColorIdx === ci ? C.ink : "transparent",
                        color: form.defaultColorIdx === ci ? "#fff" : C.muted,
                        border: `1px solid ${form.defaultColorIdx === ci ? C.ink : "#E0E0DE"}`,
                      }}>
                      {form.defaultColorIdx === ci ? "★ 기본" : "기본으로"}
                    </button>
                    <button onClick={() => removeColor(ci)}
                      style={{ background:"none", border:"1px solid #F0D0CE", color:"#C0392B", borderRadius:3, padding:"5px 10px", cursor:"pointer", fontSize:12, flexShrink:0 }}>
                      삭제
                    </button>
                  </div>

                  {/* 기본 이미지 (썸네일) */}
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, fontWeight:500, letterSpacing:0, color:"#555", marginBottom:8 }}>기본 이미지 (썸네일)</p>
                  <DynamicImgGrid
                    imgs={col.imgs}
                    onImg={(idx, file) => handleColorImg(ci, idx, file)}
                    onRemoveImg={(idx) => handleRemoveColorImg(ci, idx)}
                    maxCount={20} />

                  {/* 상세 이미지 */}
                  <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:12, fontWeight:500, letterSpacing:0, color:"#555", marginTop:16, marginBottom:8 }}>상세 이미지</p>
                  <DynamicImgGrid
                    imgs={col.galleryImgs}
                    onImg={(idx, file) => handleColorGalleryImg(ci, idx, file)}
                    onRemoveImg={(idx) => handleRemoveColorGalleryImg(ci, idx)}
                    maxCount={20} />
                </div>
              ))}
            </div>

            <div style={{ display:"flex", gap:10 }}>
              <button className="adm-btn" onClick={saveProduct} disabled={saving} style={{ background:C.ink, color:"#fff", flex:1, fontSize:13, opacity: saving ? 0.6 : 1 }}>
                {saving ? "저장 중..." : view === "add" ? "제품 추가" : "변경사항 저장"}
              </button>
              <button className="adm-btn" onClick={() => setView("list")} style={{ background:"transparent", color:C.muted, border:"1px solid #E0E0DE", fontSize:13 }}>
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
